/**
 * Historical 3-Month Treasury Bill Rates (DTB3)
 * Source: Federal Reserve Economic Data (FRED), St. Louis Federal Reserve
 * Data series: DTB3 (Market Yield on U.S. Treasury Securities at 3-Month Constant Maturity)
 *
 * Values are annual percentages (e.g., 4.32 = 4.32% annual rate)
 * Keys are dates in YYYY-MM-DD format (US Eastern time)
 *
 * Used for calculating risk-free rate in Sharpe/Sortino ratio calculations.
 *
 * @see https://fred.stlouisfed.org/series/DTB3
 *
 * ## How to Update (for Claude or developers)
 *
 * 1. Download CSV from FRED:
 *    https://fred.stlouisfed.org/graph/fredgraph.csv?id=DTB3&cosd=YYYY-MM-DD&coed=YYYY-MM-DD
 *    Replace YYYY-MM-DD with your date range (cosd = start, coed = end)
 *
 * 2. CSV format is:
 *    DATE,DTB3
 *    2026-01-02,3.54
 *    2026-01-03,3.54
 *    ...
 *
 * 3. Add entries to this file in the format:
 *    "YYYY-MM-DD": X.XX,
 *
 * 4. Run tests to verify: npm test -- tests/unit/risk-free-rate.test.ts
 *
 * Note: Rates are only available for trading days (weekdays, excluding market holidays).
 * The lookup utility handles weekends/holidays by finding the most recent prior trading day.
 */
export const TREASURY_RATES: Record<string, number> = {
  "2013-01-02": 0.08,
  "2013-01-03": 0.08,
  "2013-01-04": 0.07,
  "2013-01-07": 0.07,
  "2013-01-08": 0.07,
  "2013-01-09": 0.06,
  "2013-01-10": 0.06,
  "2013-01-11": 0.07,
  "2013-01-14": 0.08,
  "2013-01-15": 0.09,
  "2013-01-16": 0.08,
  "2013-01-17": 0.07,
  "2013-01-18": 0.08,
  "2013-01-22": 0.08,
  "2013-01-23": 0.08,
  "2013-01-24": 0.08,
  "2013-01-25": 0.08,
  "2013-01-28": 0.07,
  "2013-01-29": 0.07,
  "2013-01-30": 0.07,
  "2013-01-31": 0.07,
  "2013-02-01": 0.06,
  "2013-02-04": 0.07,
  "2013-02-05": 0.07,
  "2013-02-06": 0.07,
  "2013-02-07": 0.07,
  "2013-02-08": 0.07,
  "2013-02-11": 0.09,
  "2013-02-12": 0.09,
  "2013-02-13": 0.1,
  "2013-02-14": 0.11,
  "2013-02-15": 0.1,
  "2013-02-19": 0.12,
  "2013-02-20": 0.12,
  "2013-02-21": 0.13,
  "2013-02-22": 0.13,
  "2013-02-25": 0.12,
  "2013-02-26": 0.14,
  "2013-02-27": 0.11,
  "2013-02-28": 0.11,
  "2013-03-01": 0.11,
  "2013-03-04": 0.11,
  "2013-03-05": 0.08,
  "2013-03-06": 0.1,
  "2013-03-07": 0.1,
  "2013-03-08": 0.1,
  "2013-03-11": 0.1,
  "2013-03-12": 0.1,
  "2013-03-13": 0.09,
  "2013-03-14": 0.1,
  "2013-03-15": 0.09,
  "2013-03-18": 0.07,
  "2013-03-19": 0.07,
  "2013-03-20": 0.07,
  "2013-03-21": 0.07,
  "2013-03-22": 0.07,
  "2013-03-25": 0.08,
  "2013-03-26": 0.07,
  "2013-03-27": 0.09,
  "2013-03-28": 0.07,
  "2013-04-01": 0.08,
  "2013-04-02": 0.07,
  "2013-04-03": 0.06,
  "2013-04-04": 0.07,
  "2013-04-05": 0.07,
  "2013-04-08": 0.07,
  "2013-04-09": 0.06,
  "2013-04-10": 0.07,
  "2013-04-11": 0.07,
  "2013-04-12": 0.06,
  "2013-04-15": 0.06,
  "2013-04-16": 0.06,
  "2013-04-17": 0.06,
  "2013-04-18": 0.05,
  "2013-04-19": 0.05,
  "2013-04-22": 0.05,
  "2013-04-23": 0.05,
  "2013-04-24": 0.06,
  "2013-04-25": 0.05,
  "2013-04-26": 0.05,
  "2013-04-29": 0.05,
  "2013-04-30": 0.05,
  "2013-05-01": 0.06,
  "2013-05-02": 0.05,
  "2013-05-03": 0.05,
  "2013-05-06": 0.04,
  "2013-05-07": 0.04,
  "2013-05-08": 0.04,
  "2013-05-09": 0.04,
  "2013-05-10": 0.04,
  "2013-05-13": 0.05,
  "2013-05-14": 0.05,
  "2013-05-15": 0.04,
  "2013-05-16": 0.03,
  "2013-05-17": 0.04,
  "2013-05-20": 0.05,
  "2013-05-21": 0.04,
  "2013-05-22": 0.04,
  "2013-05-23": 0.05,
  "2013-05-24": 0.04,
  "2013-05-28": 0.05,
  "2013-05-29": 0.05,
  "2013-05-30": 0.04,
  "2013-05-31": 0.04,
  "2013-06-03": 0.05,
  "2013-06-04": 0.04,
  "2013-06-05": 0.05,
  "2013-06-06": 0.05,
  "2013-06-07": 0.04,
  "2013-06-10": 0.05,
  "2013-06-11": 0.05,
  "2013-06-12": 0.05,
  "2013-06-13": 0.05,
  "2013-06-14": 0.05,
  "2013-06-17": 0.05,
  "2013-06-18": 0.05,
  "2013-06-19": 0.05,
  "2013-06-20": 0.05,
  "2013-06-21": 0.05,
  "2013-06-24": 0.06,
  "2013-06-25": 0.06,
  "2013-06-26": 0.06,
  "2013-06-27": 0.06,
  "2013-06-28": 0.04,
  "2013-07-01": 0.04,
  "2013-07-02": 0.03,
  "2013-07-03": 0.05,
  "2013-07-05": 0.04,
  "2013-07-08": 0.05,
  "2013-07-09": 0.04,
  "2013-07-10": 0.04,
  "2013-07-11": 0.04,
  "2013-07-12": 0.04,
  "2013-07-15": 0.04,
  "2013-07-16": 0.03,
  "2013-07-17": 0.03,
  "2013-07-18": 0.03,
  "2013-07-19": 0.03,
  "2013-07-22": 0.04,
  "2013-07-23": 0.02,
  "2013-07-24": 0.03,
  "2013-07-25": 0.02,
  "2013-07-26": 0.03,
  "2013-07-29": 0.03,
  "2013-07-30": 0.04,
  "2013-07-31": 0.04,
  "2013-08-01": 0.04,
  "2013-08-02": 0.04,
  "2013-08-05": 0.05,
  "2013-08-06": 0.04,
  "2013-08-07": 0.05,
  "2013-08-08": 0.05,
  "2013-08-09": 0.05,
  "2013-08-12": 0.06,
  "2013-08-13": 0.06,
  "2013-08-14": 0.05,
  "2013-08-15": 0.05,
  "2013-08-16": 0.05,
  "2013-08-19": 0.06,
  "2013-08-20": 0.04,
  "2013-08-21": 0.04,
  "2013-08-22": 0.03,
  "2013-08-23": 0.03,
  "2013-08-26": 0.04,
  "2013-08-27": 0.05,
  "2013-08-28": 0.03,
  "2013-08-29": 0.02,
  "2013-08-30": 0.03,
  "2013-09-03": 0.02,
  "2013-09-04": 0.02,
  "2013-09-05": 0.02,
  "2013-09-06": 0.02,
  "2013-09-09": 0.02,
  "2013-09-10": 0.02,
  "2013-09-11": 0.02,
  "2013-09-12": 0.01,
  "2013-09-13": 0.01,
  "2013-09-16": 0.02,
  "2013-09-17": 0.01,
  "2013-09-18": 0.01,
  "2013-09-19": 0.01,
  "2013-09-20": 0.01,
  "2013-09-23": 0.02,
  "2013-09-24": 0.02,
  "2013-09-25": 0.02,
  "2013-09-26": 0.0,
  "2013-09-27": 0.02,
  "2013-09-30": 0.02,
  "2013-10-01": 0.02,
  "2013-10-02": 0.02,
  "2013-10-03": 0.03,
  "2013-10-04": 0.03,
  "2013-10-07": 0.03,
  "2013-10-08": 0.05,
  "2013-10-09": 0.05,
  "2013-10-10": 0.05,
  "2013-10-11": 0.08,
  "2013-10-15": 0.14,
  "2013-10-16": 0.1,
  "2013-10-17": 0.05,
  "2013-10-18": 0.04,
  "2013-10-21": 0.04,
  "2013-10-22": 0.04,
  "2013-10-23": 0.04,
  "2013-10-24": 0.03,
  "2013-10-25": 0.04,
  "2013-10-28": 0.04,
  "2013-10-29": 0.04,
  "2013-10-30": 0.04,
  "2013-10-31": 0.04,
  "2013-11-01": 0.04,
  "2013-11-04": 0.05,
  "2013-11-05": 0.05,
  "2013-11-06": 0.05,
  "2013-11-07": 0.05,
  "2013-11-08": 0.06,
  "2013-11-12": 0.08,
  "2013-11-13": 0.08,
  "2013-11-14": 0.08,
  "2013-11-15": 0.08,
  "2013-11-18": 0.09,
  "2013-11-19": 0.08,
  "2013-11-20": 0.08,
  "2013-11-21": 0.07,
  "2013-11-22": 0.07,
  "2013-11-25": 0.08,
  "2013-11-26": 0.07,
  "2013-11-27": 0.07,
  "2013-11-29": 0.06,
  "2013-12-02": 0.05,
  "2013-12-03": 0.06,
  "2013-12-04": 0.06,
  "2013-12-05": 0.06,
  "2013-12-06": 0.06,
  "2013-12-09": 0.07,
  "2013-12-10": 0.07,
  "2013-12-11": 0.07,
  "2013-12-12": 0.07,
  "2013-12-13": 0.07,
  "2013-12-16": 0.07,
  "2013-12-17": 0.07,
  "2013-12-18": 0.07,
  "2013-12-19": 0.06,
  "2013-12-20": 0.07,
  "2013-12-23": 0.07,
  "2013-12-24": 0.07,
  "2013-12-26": 0.07,
  "2013-12-27": 0.07,
  "2013-12-30": 0.07,
  "2013-12-31": 0.07,
  "2014-01-02": 0.07,
  "2014-01-03": 0.07,
  "2014-01-06": 0.05,
  "2014-01-07": 0.04,
  "2014-01-08": 0.05,
  "2014-01-09": 0.04,
  "2014-01-10": 0.05,
  "2014-01-13": 0.03,
  "2014-01-14": 0.04,
  "2014-01-15": 0.04,
  "2014-01-16": 0.04,
  "2014-01-17": 0.05,
  "2014-01-21": 0.04,
  "2014-01-22": 0.04,
  "2014-01-23": 0.04,
  "2014-01-24": 0.04,
  "2014-01-27": 0.05,
  "2014-01-28": 0.05,
  "2014-01-29": 0.04,
  "2014-01-30": 0.02,
  "2014-01-31": 0.02,
  "2014-02-03": 0.05,
  "2014-02-04": 0.06,
  "2014-02-05": 0.07,
  "2014-02-06": 0.07,
  "2014-02-07": 0.08,
  "2014-02-10": 0.07,
  "2014-02-11": 0.05,
  "2014-02-12": 0.05,
  "2014-02-13": 0.03,
  "2014-02-14": 0.02,
  "2014-02-18": 0.05,
  "2014-02-19": 0.06,
  "2014-02-20": 0.05,
  "2014-02-21": 0.05,
  "2014-02-24": 0.05,
  "2014-02-25": 0.05,
  "2014-02-26": 0.05,
  "2014-02-27": 0.04,
  "2014-02-28": 0.05,
  "2014-03-03": 0.05,
  "2014-03-04": 0.05,
  "2014-03-05": 0.06,
  "2014-03-06": 0.05,
  "2014-03-07": 0.06,
  "2014-03-10": 0.05,
  "2014-03-11": 0.05,
  "2014-03-12": 0.05,
  "2014-03-13": 0.05,
  "2014-03-14": 0.05,
  "2014-03-17": 0.06,
  "2014-03-18": 0.05,
  "2014-03-19": 0.06,
  "2014-03-20": 0.06,
  "2014-03-21": 0.06,
  "2014-03-24": 0.06,
  "2014-03-25": 0.05,
  "2014-03-26": 0.05,
  "2014-03-27": 0.04,
  "2014-03-28": 0.04,
  "2014-03-31": 0.05,
  "2014-04-01": 0.04,
  "2014-04-02": 0.02,
  "2014-04-03": 0.02,
  "2014-04-04": 0.03,
  "2014-04-07": 0.03,
  "2014-04-08": 0.03,
  "2014-04-09": 0.04,
  "2014-04-10": 0.04,
  "2014-04-11": 0.04,
  "2014-04-14": 0.04,
  "2014-04-15": 0.04,
  "2014-04-16": 0.04,
  "2014-04-17": 0.03,
  "2014-04-21": 0.04,
  "2014-04-22": 0.03,
  "2014-04-23": 0.02,
  "2014-04-24": 0.01,
  "2014-04-25": 0.03,
  "2014-04-28": 0.03,
  "2014-04-29": 0.02,
  "2014-04-30": 0.03,
  "2014-05-01": 0.03,
  "2014-05-02": 0.02,
  "2014-05-05": 0.03,
  "2014-05-06": 0.03,
  "2014-05-07": 0.03,
  "2014-05-08": 0.03,
  "2014-05-09": 0.03,
  "2014-05-12": 0.03,
  "2014-05-13": 0.03,
  "2014-05-14": 0.03,
  "2014-05-15": 0.03,
  "2014-05-16": 0.03,
  "2014-05-19": 0.03,
  "2014-05-20": 0.03,
  "2014-05-21": 0.04,
  "2014-05-22": 0.03,
  "2014-05-23": 0.04,
  "2014-05-27": 0.04,
  "2014-05-28": 0.04,
  "2014-05-29": 0.04,
  "2014-05-30": 0.04,
  "2014-06-02": 0.04,
  "2014-06-03": 0.04,
  "2014-06-04": 0.04,
  "2014-06-05": 0.04,
  "2014-06-06": 0.04,
  "2014-06-09": 0.04,
  "2014-06-10": 0.04,
  "2014-06-11": 0.04,
  "2014-06-12": 0.04,
  "2014-06-13": 0.04,
  "2014-06-16": 0.04,
  "2014-06-17": 0.04,
  "2014-06-18": 0.03,
  "2014-06-19": 0.02,
  "2014-06-20": 0.02,
  "2014-06-23": 0.03,
  "2014-06-24": 0.03,
  "2014-06-25": 0.03,
  "2014-06-26": 0.04,
  "2014-06-27": 0.03,
  "2014-06-30": 0.04,
  "2014-07-01": 0.02,
  "2014-07-02": 0.02,
  "2014-07-03": 0.01,
  "2014-07-07": 0.04,
  "2014-07-08": 0.03,
  "2014-07-09": 0.03,
  "2014-07-10": 0.02,
  "2014-07-11": 0.02,
  "2014-07-14": 0.03,
  "2014-07-15": 0.02,
  "2014-07-16": 0.02,
  "2014-07-17": 0.02,
  "2014-07-18": 0.02,
  "2014-07-21": 0.03,
  "2014-07-22": 0.03,
  "2014-07-23": 0.03,
  "2014-07-24": 0.03,
  "2014-07-25": 0.03,
  "2014-07-28": 0.04,
  "2014-07-29": 0.02,
  "2014-07-30": 0.04,
  "2014-07-31": 0.03,
  "2014-08-01": 0.03,
  "2014-08-04": 0.04,
  "2014-08-05": 0.03,
  "2014-08-06": 0.03,
  "2014-08-07": 0.03,
  "2014-08-08": 0.03,
  "2014-08-11": 0.04,
  "2014-08-12": 0.03,
  "2014-08-13": 0.04,
  "2014-08-14": 0.04,
  "2014-08-15": 0.03,
  "2014-08-18": 0.03,
  "2014-08-19": 0.03,
  "2014-08-20": 0.04,
  "2014-08-21": 0.02,
  "2014-08-22": 0.03,
  "2014-08-25": 0.04,
  "2014-08-26": 0.03,
  "2014-08-27": 0.04,
  "2014-08-28": 0.03,
  "2014-08-29": 0.03,
  "2014-09-02": 0.03,
  "2014-09-03": 0.03,
  "2014-09-04": 0.03,
  "2014-09-05": 0.03,
  "2014-09-08": 0.02,
  "2014-09-09": 0.02,
  "2014-09-10": 0.02,
  "2014-09-11": 0.02,
  "2014-09-12": 0.02,
  "2014-09-15": 0.02,
  "2014-09-16": 0.02,
  "2014-09-17": 0.02,
  "2014-09-18": 0.02,
  "2014-09-19": 0.02,
  "2014-09-22": 0.01,
  "2014-09-23": 0.01,
  "2014-09-24": 0.02,
  "2014-09-25": 0.01,
  "2014-09-26": 0.01,
  "2014-09-29": 0.02,
  "2014-09-30": 0.02,
  "2014-10-01": 0.02,
  "2014-10-02": 0.01,
  "2014-10-03": 0.01,
  "2014-10-06": 0.02,
  "2014-10-07": 0.02,
  "2014-10-08": 0.01,
  "2014-10-09": 0.01,
  "2014-10-10": 0.01,
  "2014-10-14": 0.02,
  "2014-10-15": 0.02,
  "2014-10-16": 0.03,
  "2014-10-17": 0.02,
  "2014-10-20": 0.02,
  "2014-10-21": 0.02,
  "2014-10-22": 0.02,
  "2014-10-23": 0.01,
  "2014-10-24": 0.01,
  "2014-10-27": 0.02,
  "2014-10-28": 0.02,
  "2014-10-29": 0.03,
  "2014-10-30": 0.01,
  "2014-10-31": 0.01,
  "2014-11-03": 0.02,
  "2014-11-04": 0.03,
  "2014-11-05": 0.03,
  "2014-11-06": 0.03,
  "2014-11-07": 0.03,
  "2014-11-10": 0.02,
  "2014-11-12": 0.02,
  "2014-11-13": 0.02,
  "2014-11-14": 0.02,
  "2014-11-17": 0.03,
  "2014-11-18": 0.02,
  "2014-11-19": 0.01,
  "2014-11-20": 0.02,
  "2014-11-21": 0.01,
  "2014-11-24": 0.02,
  "2014-11-25": 0.02,
  "2014-11-26": 0.02,
  "2014-11-28": 0.02,
  "2014-12-01": 0.03,
  "2014-12-02": 0.03,
  "2014-12-03": 0.01,
  "2014-12-04": 0.02,
  "2014-12-05": 0.02,
  "2014-12-08": 0.03,
  "2014-12-09": 0.04,
  "2014-12-10": 0.03,
  "2014-12-11": 0.03,
  "2014-12-12": 0.02,
  "2014-12-15": 0.04,
  "2014-12-16": 0.03,
  "2014-12-17": 0.03,
  "2014-12-18": 0.04,
  "2014-12-19": 0.04,
  "2014-12-22": 0.05,
  "2014-12-23": 0.03,
  "2014-12-24": 0.01,
  "2014-12-26": 0.01,
  "2014-12-29": 0.03,
  "2014-12-30": 0.03,
  "2014-12-31": 0.04,
  "2015-01-02": 0.02,
  "2015-01-05": 0.03,
  "2015-01-06": 0.03,
  "2015-01-07": 0.03,
  "2015-01-08": 0.03,
  "2015-01-09": 0.02,
  "2015-01-12": 0.03,
  "2015-01-13": 0.03,
  "2015-01-14": 0.04,
  "2015-01-15": 0.03,
  "2015-01-16": 0.03,
  "2015-01-20": 0.03,
  "2015-01-21": 0.03,
  "2015-01-22": 0.03,
  "2015-01-23": 0.02,
  "2015-01-26": 0.03,
  "2015-01-27": 0.02,
  "2015-01-28": 0.02,
  "2015-01-29": 0.03,
  "2015-01-30": 0.02,
  "2015-02-02": 0.02,
  "2015-02-03": 0.02,
  "2015-02-04": 0.01,
  "2015-02-05": 0.02,
  "2015-02-06": 0.02,
  "2015-02-09": 0.01,
  "2015-02-10": 0.01,
  "2015-02-11": 0.01,
  "2015-02-12": 0.02,
  "2015-02-13": 0.01,
  "2015-02-17": 0.02,
  "2015-02-18": 0.02,
  "2015-02-19": 0.02,
  "2015-02-20": 0.02,
  "2015-02-23": 0.02,
  "2015-02-24": 0.02,
  "2015-02-25": 0.02,
  "2015-02-26": 0.03,
  "2015-02-27": 0.02,
  "2015-03-02": 0.02,
  "2015-03-03": 0.02,
  "2015-03-04": 0.01,
  "2015-03-05": 0.02,
  "2015-03-06": 0.01,
  "2015-03-09": 0.02,
  "2015-03-10": 0.02,
  "2015-03-11": 0.03,
  "2015-03-12": 0.03,
  "2015-03-13": 0.03,
  "2015-03-16": 0.05,
  "2015-03-17": 0.05,
  "2015-03-18": 0.03,
  "2015-03-19": 0.03,
  "2015-03-20": 0.01,
  "2015-03-23": 0.03,
  "2015-03-24": 0.02,
  "2015-03-25": 0.04,
  "2015-03-26": 0.03,
  "2015-03-27": 0.04,
  "2015-03-30": 0.04,
  "2015-03-31": 0.03,
  "2015-04-01": 0.03,
  "2015-04-02": 0.02,
  "2015-04-03": 0.02,
  "2015-04-06": 0.03,
  "2015-04-07": 0.02,
  "2015-04-08": 0.03,
  "2015-04-09": 0.03,
  "2015-04-10": 0.02,
  "2015-04-13": 0.03,
  "2015-04-14": 0.02,
  "2015-04-15": 0.02,
  "2015-04-16": 0.02,
  "2015-04-17": 0.01,
  "2015-04-20": 0.03,
  "2015-04-21": 0.03,
  "2015-04-22": 0.03,
  "2015-04-23": 0.03,
  "2015-04-24": 0.03,
  "2015-04-27": 0.02,
  "2015-04-28": 0.02,
  "2015-04-29": 0.01,
  "2015-04-30": 0.01,
  "2015-05-01": 0.01,
  "2015-05-04": 0.02,
  "2015-05-05": 0.01,
  "2015-05-06": 0.02,
  "2015-05-07": 0.01,
  "2015-05-08": 0.01,
  "2015-05-11": 0.02,
  "2015-05-12": 0.03,
  "2015-05-13": 0.02,
  "2015-05-14": 0.01,
  "2015-05-15": 0.02,
  "2015-05-18": 0.02,
  "2015-05-19": 0.02,
  "2015-05-20": 0.02,
  "2015-05-21": 0.02,
  "2015-05-22": 0.02,
  "2015-05-26": 0.02,
  "2015-05-27": 0.01,
  "2015-05-28": 0.01,
  "2015-05-29": 0.01,
  "2015-06-01": 0.02,
  "2015-06-02": 0.01,
  "2015-06-03": 0.02,
  "2015-06-04": 0.02,
  "2015-06-05": 0.03,
  "2015-06-08": 0.02,
  "2015-06-09": 0.02,
  "2015-06-10": 0.02,
  "2015-06-11": 0.01,
  "2015-06-12": 0.02,
  "2015-06-15": 0.02,
  "2015-06-16": 0.01,
  "2015-06-17": 0.01,
  "2015-06-18": 0.01,
  "2015-06-19": 0.01,
  "2015-06-22": 0.01,
  "2015-06-23": 0.01,
  "2015-06-24": 0.01,
  "2015-06-25": 0.01,
  "2015-06-26": 0.01,
  "2015-06-29": 0.02,
  "2015-06-30": 0.01,
  "2015-07-01": 0.01,
  "2015-07-02": 0.01,
  "2015-07-06": 0.02,
  "2015-07-07": 0.02,
  "2015-07-08": 0.02,
  "2015-07-09": 0.03,
  "2015-07-10": 0.01,
  "2015-07-13": 0.02,
  "2015-07-14": 0.01,
  "2015-07-15": 0.02,
  "2015-07-16": 0.02,
  "2015-07-17": 0.03,
  "2015-07-20": 0.04,
  "2015-07-21": 0.03,
  "2015-07-22": 0.04,
  "2015-07-23": 0.03,
  "2015-07-24": 0.04,
  "2015-07-27": 0.05,
  "2015-07-28": 0.05,
  "2015-07-29": 0.06,
  "2015-07-30": 0.07,
  "2015-07-31": 0.08,
  "2015-08-03": 0.08,
  "2015-08-04": 0.08,
  "2015-08-05": 0.08,
  "2015-08-06": 0.04,
  "2015-08-07": 0.06,
  "2015-08-10": 0.12,
  "2015-08-11": 0.1,
  "2015-08-12": 0.1,
  "2015-08-13": 0.1,
  "2015-08-14": 0.09,
  "2015-08-17": 0.1,
  "2015-08-18": 0.07,
  "2015-08-19": 0.05,
  "2015-08-20": 0.02,
  "2015-08-21": 0.03,
  "2015-08-24": 0.06,
  "2015-08-25": 0.07,
  "2015-08-26": 0.06,
  "2015-08-27": 0.06,
  "2015-08-28": 0.06,
  "2015-08-31": 0.08,
  "2015-09-01": 0.03,
  "2015-09-02": 0.03,
  "2015-09-03": 0.02,
  "2015-09-04": 0.02,
  "2015-09-08": 0.06,
  "2015-09-09": 0.03,
  "2015-09-10": 0.02,
  "2015-09-11": 0.04,
  "2015-09-14": 0.07,
  "2015-09-15": 0.07,
  "2015-09-16": 0.06,
  "2015-09-17": 0.01,
  "2015-09-18": -0.01,
  "2015-09-21": 0.01,
  "2015-09-22": -0.01,
  "2015-09-23": 0.01,
  "2015-09-24": 0.01,
  "2015-09-25": -0.01,
  "2015-09-28": 0.01,
  "2015-09-29": 0.01,
  "2015-09-30": -0.01,
  "2015-10-01": -0.02,
  "2015-10-02": 0.0,
  "2015-10-05": 0.01,
  "2015-10-06": 0.0,
  "2015-10-07": 0.0,
  "2015-10-08": -0.01,
  "2015-10-09": 0.01,
  "2015-10-13": 0.01,
  "2015-10-14": 0.0,
  "2015-10-15": 0.01,
  "2015-10-16": 0.01,
  "2015-10-19": 0.02,
  "2015-10-20": 0.02,
  "2015-10-21": 0.01,
  "2015-10-22": 0.0,
  "2015-10-23": 0.01,
  "2015-10-26": 0.02,
  "2015-10-27": 0.03,
  "2015-10-28": 0.04,
  "2015-10-29": 0.07,
  "2015-10-30": 0.08,
  "2015-11-02": 0.08,
  "2015-11-03": 0.06,
  "2015-11-04": 0.05,
  "2015-11-05": 0.05,
  "2015-11-06": 0.08,
  "2015-11-09": 0.14,
  "2015-11-10": 0.13,
  "2015-11-12": 0.14,
  "2015-11-13": 0.13,
  "2015-11-16": 0.15,
  "2015-11-17": 0.14,
  "2015-11-18": 0.12,
  "2015-11-19": 0.11,
  "2015-11-20": 0.11,
  "2015-11-23": 0.14,
  "2015-11-24": 0.16,
  "2015-11-25": 0.19,
  "2015-11-27": 0.17,
  "2015-11-30": 0.22,
  "2015-12-01": 0.21,
  "2015-12-02": 0.21,
  "2015-12-03": 0.21,
  "2015-12-04": 0.22,
  "2015-12-07": 0.29,
  "2015-12-08": 0.27,
  "2015-12-09": 0.26,
  "2015-12-10": 0.24,
  "2015-12-11": 0.22,
  "2015-12-14": 0.26,
  "2015-12-15": 0.25,
  "2015-12-16": 0.27,
  "2015-12-17": 0.23,
  "2015-12-18": 0.19,
  "2015-12-21": 0.24,
  "2015-12-22": 0.21,
  "2015-12-23": 0.2,
  "2015-12-24": 0.2,
  "2015-12-28": 0.23,
  "2015-12-29": 0.23,
  "2015-12-30": 0.21,
  "2015-12-31": 0.16,
  "2016-01-04": 0.22,
  "2016-01-05": 0.2,
  "2016-01-06": 0.21,
  "2016-01-07": 0.2,
  "2016-01-08": 0.2,
  "2016-01-11": 0.21,
  "2016-01-12": 0.21,
  "2016-01-13": 0.22,
  "2016-01-14": 0.25,
  "2016-01-15": 0.23,
  "2016-01-19": 0.26,
  "2016-01-20": 0.26,
  "2016-01-21": 0.28,
  "2016-01-22": 0.3,
  "2016-01-25": 0.31,
  "2016-01-26": 0.31,
  "2016-01-27": 0.32,
  "2016-01-28": 0.34,
  "2016-01-29": 0.32,
  "2016-02-01": 0.35,
  "2016-02-02": 0.34,
  "2016-02-03": 0.33,
  "2016-02-04": 0.29,
  "2016-02-05": 0.29,
  "2016-02-08": 0.32,
  "2016-02-09": 0.3,
  "2016-02-10": 0.31,
  "2016-02-11": 0.28,
  "2016-02-12": 0.29,
  "2016-02-16": 0.3,
  "2016-02-17": 0.3,
  "2016-02-18": 0.3,
  "2016-02-19": 0.3,
  "2016-02-22": 0.33,
  "2016-02-23": 0.32,
  "2016-02-24": 0.33,
  "2016-02-25": 0.32,
  "2016-02-26": 0.32,
  "2016-02-29": 0.33,
  "2016-03-01": 0.33,
  "2016-03-02": 0.35,
  "2016-03-03": 0.27,
  "2016-03-04": 0.28,
  "2016-03-07": 0.32,
  "2016-03-08": 0.29,
  "2016-03-09": 0.3,
  "2016-03-10": 0.31,
  "2016-03-11": 0.32,
  "2016-03-14": 0.34,
  "2016-03-15": 0.34,
  "2016-03-16": 0.31,
  "2016-03-17": 0.29,
  "2016-03-18": 0.29,
  "2016-03-21": 0.31,
  "2016-03-22": 0.3,
  "2016-03-23": 0.3,
  "2016-03-24": 0.29,
  "2016-03-28": 0.29,
  "2016-03-29": 0.23,
  "2016-03-30": 0.2,
  "2016-03-31": 0.21,
  "2016-04-01": 0.23,
  "2016-04-04": 0.23,
  "2016-04-05": 0.23,
  "2016-04-06": 0.23,
  "2016-04-07": 0.23,
  "2016-04-08": 0.23,
  "2016-04-11": 0.23,
  "2016-04-12": 0.22,
  "2016-04-13": 0.23,
  "2016-04-14": 0.22,
  "2016-04-15": 0.22,
  "2016-04-18": 0.22,
  "2016-04-19": 0.21,
  "2016-04-20": 0.23,
  "2016-04-21": 0.23,
  "2016-04-22": 0.23,
  "2016-04-25": 0.25,
  "2016-04-26": 0.24,
  "2016-04-27": 0.24,
  "2016-04-28": 0.22,
  "2016-04-29": 0.22,
  "2016-05-02": 0.22,
  "2016-05-03": 0.21,
  "2016-05-04": 0.19,
  "2016-05-05": 0.2,
  "2016-05-06": 0.19,
  "2016-05-09": 0.24,
  "2016-05-10": 0.24,
  "2016-05-11": 0.26,
  "2016-05-12": 0.27,
  "2016-05-13": 0.28,
  "2016-05-16": 0.28,
  "2016-05-17": 0.28,
  "2016-05-18": 0.3,
  "2016-05-19": 0.3,
  "2016-05-20": 0.32,
  "2016-05-23": 0.35,
  "2016-05-24": 0.35,
  "2016-05-25": 0.33,
  "2016-05-26": 0.3,
  "2016-05-27": 0.31,
  "2016-05-31": 0.34,
  "2016-06-01": 0.3,
  "2016-06-02": 0.28,
  "2016-06-03": 0.29,
  "2016-06-06": 0.28,
  "2016-06-07": 0.28,
  "2016-06-08": 0.24,
  "2016-06-09": 0.25,
  "2016-06-10": 0.25,
  "2016-06-13": 0.27,
  "2016-06-14": 0.27,
  "2016-06-15": 0.26,
  "2016-06-16": 0.27,
  "2016-06-17": 0.26,
  "2016-06-20": 0.28,
  "2016-06-21": 0.27,
  "2016-06-22": 0.27,
  "2016-06-23": 0.3,
  "2016-06-24": 0.26,
  "2016-06-27": 0.27,
  "2016-06-28": 0.26,
  "2016-06-29": 0.26,
  "2016-06-30": 0.26,
  "2016-07-01": 0.27,
  "2016-07-05": 0.28,
  "2016-07-06": 0.27,
  "2016-07-07": 0.29,
  "2016-07-08": 0.27,
  "2016-07-11": 0.31,
  "2016-07-12": 0.29,
  "2016-07-13": 0.31,
  "2016-07-14": 0.31,
  "2016-07-15": 0.31,
  "2016-07-18": 0.32,
  "2016-07-19": 0.31,
  "2016-07-20": 0.32,
  "2016-07-21": 0.31,
  "2016-07-22": 0.32,
  "2016-07-25": 0.32,
  "2016-07-26": 0.31,
  "2016-07-27": 0.31,
  "2016-07-28": 0.25,
  "2016-07-29": 0.27,
  "2016-08-01": 0.29,
  "2016-08-02": 0.29,
  "2016-08-03": 0.28,
  "2016-08-04": 0.26,
  "2016-08-05": 0.27,
  "2016-08-08": 0.31,
  "2016-08-09": 0.29,
  "2016-08-10": 0.28,
  "2016-08-11": 0.28,
  "2016-08-12": 0.28,
  "2016-08-15": 0.31,
  "2016-08-16": 0.27,
  "2016-08-17": 0.3,
  "2016-08-18": 0.29,
  "2016-08-19": 0.29,
  "2016-08-22": 0.29,
  "2016-08-23": 0.3,
  "2016-08-24": 0.31,
  "2016-08-25": 0.33,
  "2016-08-26": 0.33,
  "2016-08-29": 0.33,
  "2016-08-30": 0.33,
  "2016-08-31": 0.33,
  "2016-09-01": 0.33,
  "2016-09-02": 0.32,
  "2016-09-06": 0.32,
  "2016-09-07": 0.34,
  "2016-09-08": 0.34,
  "2016-09-09": 0.34,
  "2016-09-12": 0.37,
  "2016-09-13": 0.36,
  "2016-09-14": 0.33,
  "2016-09-15": 0.29,
  "2016-09-16": 0.29,
  "2016-09-19": 0.3,
  "2016-09-20": 0.3,
  "2016-09-21": 0.22,
  "2016-09-22": 0.18,
  "2016-09-23": 0.18,
  "2016-09-26": 0.25,
  "2016-09-27": 0.26,
  "2016-09-28": 0.27,
  "2016-09-29": 0.26,
  "2016-09-30": 0.28,
  "2016-10-03": 0.32,
  "2016-10-04": 0.33,
  "2016-10-05": 0.32,
  "2016-10-06": 0.32,
  "2016-10-07": 0.32,
  "2016-10-11": 0.35,
  "2016-10-12": 0.36,
  "2016-10-13": 0.29,
  "2016-10-14": 0.31,
  "2016-10-17": 0.34,
  "2016-10-18": 0.34,
  "2016-10-19": 0.34,
  "2016-10-20": 0.34,
  "2016-10-21": 0.33,
  "2016-10-24": 0.33,
  "2016-10-25": 0.34,
  "2016-10-26": 0.33,
  "2016-10-27": 0.29,
  "2016-10-28": 0.29,
  "2016-10-31": 0.34,
  "2016-11-01": 0.35,
  "2016-11-02": 0.36,
  "2016-11-03": 0.37,
  "2016-11-04": 0.37,
  "2016-11-07": 0.41,
  "2016-11-08": 0.43,
  "2016-11-09": 0.44,
  "2016-11-10": 0.47,
  "2016-11-14": 0.54,
  "2016-11-15": 0.5,
  "2016-11-16": 0.46,
  "2016-11-17": 0.43,
  "2016-11-18": 0.43,
  "2016-11-21": 0.46,
  "2016-11-22": 0.48,
  "2016-11-23": 0.5,
  "2016-11-25": 0.48,
  "2016-11-28": 0.48,
  "2016-11-29": 0.48,
  "2016-11-30": 0.48,
  "2016-12-01": 0.47,
  "2016-12-02": 0.48,
  "2016-12-05": 0.49,
  "2016-12-06": 0.49,
  "2016-12-07": 0.51,
  "2016-12-08": 0.5,
  "2016-12-09": 0.53,
  "2016-12-12": 0.51,
  "2016-12-13": 0.54,
  "2016-12-14": 0.54,
  "2016-12-15": 0.5,
  "2016-12-16": 0.5,
  "2016-12-19": 0.52,
  "2016-12-20": 0.52,
  "2016-12-21": 0.51,
  "2016-12-22": 0.5,
  "2016-12-23": 0.51,
  "2016-12-27": 0.51,
  "2016-12-28": 0.52,
  "2016-12-29": 0.46,
  "2016-12-30": 0.5,
  "2017-01-03": 0.53,
  "2017-01-04": 0.52,
  "2017-01-05": 0.51,
  "2017-01-06": 0.52,
  "2017-01-09": 0.5,
  "2017-01-10": 0.51,
  "2017-01-11": 0.51,
  "2017-01-12": 0.51,
  "2017-01-13": 0.52,
  "2017-01-17": 0.54,
  "2017-01-18": 0.52,
  "2017-01-19": 0.51,
  "2017-01-20": 0.49,
  "2017-01-23": 0.51,
  "2017-01-24": 0.5,
  "2017-01-25": 0.49,
  "2017-01-26": 0.5,
  "2017-01-27": 0.51,
  "2017-01-30": 0.51,
  "2017-01-31": 0.52,
  "2017-02-01": 0.5,
  "2017-02-02": 0.51,
  "2017-02-03": 0.5,
  "2017-02-06": 0.53,
  "2017-02-07": 0.53,
  "2017-02-08": 0.53,
  "2017-02-09": 0.53,
  "2017-02-10": 0.54,
  "2017-02-13": 0.52,
  "2017-02-14": 0.54,
  "2017-02-15": 0.53,
  "2017-02-16": 0.52,
  "2017-02-17": 0.52,
  "2017-02-21": 0.53,
  "2017-02-22": 0.52,
  "2017-02-23": 0.51,
  "2017-02-24": 0.51,
  "2017-02-27": 0.5,
  "2017-02-28": 0.53,
  "2017-03-01": 0.62,
  "2017-03-02": 0.66,
  "2017-03-03": 0.7,
  "2017-03-06": 0.73,
  "2017-03-07": 0.75,
  "2017-03-08": 0.72,
  "2017-03-09": 0.72,
  "2017-03-10": 0.73,
  "2017-03-13": 0.78,
  "2017-03-14": 0.77,
  "2017-03-15": 0.72,
  "2017-03-16": 0.72,
  "2017-03-17": 0.72,
  "2017-03-20": 0.75,
  "2017-03-21": 0.76,
  "2017-03-22": 0.76,
  "2017-03-23": 0.75,
  "2017-03-24": 0.77,
  "2017-03-27": 0.77,
  "2017-03-28": 0.77,
  "2017-03-29": 0.77,
  "2017-03-30": 0.77,
  "2017-03-31": 0.75,
  "2017-04-03": 0.78,
  "2017-04-04": 0.78,
  "2017-04-05": 0.79,
  "2017-04-06": 0.78,
  "2017-04-07": 0.81,
  "2017-04-10": 0.81,
  "2017-04-11": 0.81,
  "2017-04-12": 0.8,
  "2017-04-13": 0.8,
  "2017-04-17": 0.82,
  "2017-04-18": 0.81,
  "2017-04-19": 0.8,
  "2017-04-20": 0.78,
  "2017-04-21": 0.78,
  "2017-04-24": 0.8,
  "2017-04-25": 0.81,
  "2017-04-26": 0.82,
  "2017-04-27": 0.8,
  "2017-04-28": 0.79,
  "2017-05-01": 0.82,
  "2017-05-02": 0.81,
  "2017-05-03": 0.84,
  "2017-05-04": 0.84,
  "2017-05-05": 0.88,
  "2017-05-08": 0.9,
  "2017-05-09": 0.9,
  "2017-05-10": 0.89,
  "2017-05-11": 0.87,
  "2017-05-12": 0.86,
  "2017-05-15": 0.89,
  "2017-05-16": 0.89,
  "2017-05-17": 0.89,
  "2017-05-18": 0.91,
  "2017-05-19": 0.9,
  "2017-05-22": 0.92,
  "2017-05-23": 0.91,
  "2017-05-24": 0.92,
  "2017-05-25": 0.92,
  "2017-05-26": 0.92,
  "2017-05-30": 0.92,
  "2017-05-31": 0.96,
  "2017-06-01": 0.96,
  "2017-06-02": 0.96,
  "2017-06-05": 0.95,
  "2017-06-06": 0.96,
  "2017-06-07": 0.98,
  "2017-06-08": 0.99,
  "2017-06-09": 0.99,
  "2017-06-12": 0.97,
  "2017-06-13": 0.99,
  "2017-06-14": 0.99,
  "2017-06-15": 1.0,
  "2017-06-16": 1.01,
  "2017-06-19": 1.01,
  "2017-06-20": 1.0,
  "2017-06-21": 0.97,
  "2017-06-22": 0.94,
  "2017-06-23": 0.95,
  "2017-06-26": 0.98,
  "2017-06-27": 0.99,
  "2017-06-28": 1.0,
  "2017-06-29": 1.02,
  "2017-06-30": 1.01,
  "2017-07-03": 1.04,
  "2017-07-05": 1.03,
  "2017-07-06": 1.02,
  "2017-07-07": 1.03,
  "2017-07-10": 1.03,
  "2017-07-11": 1.03,
  "2017-07-12": 1.03,
  "2017-07-13": 1.03,
  "2017-07-14": 1.02,
  "2017-07-17": 1.05,
  "2017-07-18": 1.05,
  "2017-07-19": 1.09,
  "2017-07-20": 1.13,
  "2017-07-21": 1.14,
  "2017-07-24": 1.15,
  "2017-07-25": 1.16,
  "2017-07-26": 1.11,
  "2017-07-27": 1.09,
  "2017-07-28": 1.06,
  "2017-07-31": 1.05,
  "2017-08-01": 1.06,
  "2017-08-02": 1.06,
  "2017-08-03": 1.06,
  "2017-08-04": 1.06,
  "2017-08-07": 1.01,
  "2017-08-08": 1.04,
  "2017-08-09": 1.04,
  "2017-08-10": 1.03,
  "2017-08-11": 1.01,
  "2017-08-14": 1.01,
  "2017-08-15": 1.02,
  "2017-08-16": 1.0,
  "2017-08-17": 0.98,
  "2017-08-18": 1.0,
  "2017-08-21": 0.99,
  "2017-08-22": 0.99,
  "2017-08-23": 0.98,
  "2017-08-24": 1.0,
  "2017-08-25": 1.01,
  "2017-08-28": 0.97,
  "2017-08-29": 1.01,
  "2017-08-30": 1.01,
  "2017-08-31": 0.99,
  "2017-09-01": 1.0,
  "2017-09-05": 1.01,
  "2017-09-06": 1.05,
  "2017-09-07": 1.03,
  "2017-09-08": 1.02,
  "2017-09-11": 1.04,
  "2017-09-12": 1.02,
  "2017-09-13": 1.02,
  "2017-09-14": 1.03,
  "2017-09-15": 1.03,
  "2017-09-18": 1.04,
  "2017-09-19": 1.03,
  "2017-09-20": 1.02,
  "2017-09-21": 1.02,
  "2017-09-22": 1.01,
  "2017-09-25": 1.04,
  "2017-09-26": 1.05,
  "2017-09-27": 1.05,
  "2017-09-28": 1.04,
  "2017-09-29": 1.04,
  "2017-10-02": 1.0,
  "2017-10-03": 1.05,
  "2017-10-04": 1.06,
  "2017-10-05": 1.05,
  "2017-10-06": 1.05,
  "2017-10-10": 1.06,
  "2017-10-11": 1.08,
  "2017-10-12": 1.07,
  "2017-10-13": 1.07,
  "2017-10-16": 1.09,
  "2017-10-17": 1.07,
  "2017-10-18": 1.07,
  "2017-10-19": 1.08,
  "2017-10-20": 1.09,
  "2017-10-23": 1.08,
  "2017-10-24": 1.1,
  "2017-10-25": 1.1,
  "2017-10-26": 1.09,
  "2017-10-27": 1.08,
  "2017-10-30": 1.1,
  "2017-10-31": 1.13,
  "2017-11-01": 1.16,
  "2017-11-02": 1.15,
  "2017-11-03": 1.16,
  "2017-11-06": 1.17,
  "2017-11-07": 1.2,
  "2017-11-08": 1.21,
  "2017-11-09": 1.22,
  "2017-11-10": 1.21,
  "2017-11-13": 1.22,
  "2017-11-14": 1.24,
  "2017-11-15": 1.23,
  "2017-11-16": 1.25,
  "2017-11-17": 1.26,
  "2017-11-20": 1.28,
  "2017-11-21": 1.28,
  "2017-11-22": 1.27,
  "2017-11-24": 1.26,
  "2017-11-27": 1.25,
  "2017-11-28": 1.28,
  "2017-11-29": 1.27,
  "2017-11-30": 1.25,
  "2017-12-01": 1.25,
  "2017-12-04": 1.28,
  "2017-12-05": 1.28,
  "2017-12-06": 1.28,
  "2017-12-07": 1.27,
  "2017-12-08": 1.26,
  "2017-12-11": 1.31,
  "2017-12-12": 1.32,
  "2017-12-13": 1.28,
  "2017-12-14": 1.3,
  "2017-12-15": 1.29,
  "2017-12-18": 1.36,
  "2017-12-19": 1.35,
  "2017-12-20": 1.36,
  "2017-12-21": 1.33,
  "2017-12-22": 1.31,
  "2017-12-26": 1.45,
  "2017-12-27": 1.42,
  "2017-12-28": 1.37,
  "2017-12-29": 1.37,
  "2018-01-02": 1.42,
  "2018-01-03": 1.39,
  "2018-01-04": 1.39,
  "2018-01-05": 1.37,
  "2018-01-08": 1.43,
  "2018-01-09": 1.42,
  "2018-01-10": 1.4,
  "2018-01-11": 1.41,
  "2018-01-12": 1.41,
  "2018-01-16": 1.43,
  "2018-01-17": 1.42,
  "2018-01-18": 1.43,
  "2018-01-19": 1.42,
  "2018-01-22": 1.43,
  "2018-01-23": 1.42,
  "2018-01-24": 1.41,
  "2018-01-25": 1.4,
  "2018-01-26": 1.39,
  "2018-01-29": 1.43,
  "2018-01-30": 1.42,
  "2018-01-31": 1.44,
  "2018-02-01": 1.46,
  "2018-02-02": 1.46,
  "2018-02-05": 1.49,
  "2018-02-06": 1.5,
  "2018-02-07": 1.53,
  "2018-02-08": 1.53,
  "2018-02-09": 1.53,
  "2018-02-12": 1.61,
  "2018-02-13": 1.57,
  "2018-02-14": 1.56,
  "2018-02-15": 1.56,
  "2018-02-16": 1.59,
  "2018-02-20": 1.64,
  "2018-02-21": 1.62,
  "2018-02-22": 1.61,
  "2018-02-23": 1.61,
  "2018-02-26": 1.65,
  "2018-02-27": 1.64,
  "2018-02-28": 1.63,
  "2018-03-01": 1.6,
  "2018-03-02": 1.62,
  "2018-03-05": 1.67,
  "2018-03-06": 1.65,
  "2018-03-07": 1.65,
  "2018-03-08": 1.64,
  "2018-03-09": 1.64,
  "2018-03-12": 1.68,
  "2018-03-13": 1.7,
  "2018-03-14": 1.73,
  "2018-03-15": 1.74,
  "2018-03-16": 1.75,
  "2018-03-19": 1.77,
  "2018-03-20": 1.78,
  "2018-03-21": 1.71,
  "2018-03-22": 1.69,
  "2018-03-23": 1.71,
  "2018-03-26": 1.76,
  "2018-03-27": 1.74,
  "2018-03-28": 1.7,
  "2018-03-29": 1.7,
  "2018-04-02": 1.74,
  "2018-04-03": 1.72,
  "2018-04-04": 1.68,
  "2018-04-05": 1.69,
  "2018-04-06": 1.7,
  "2018-04-09": 1.73,
  "2018-04-10": 1.71,
  "2018-04-11": 1.7,
  "2018-04-12": 1.72,
  "2018-04-13": 1.73,
  "2018-04-16": 1.76,
  "2018-04-17": 1.77,
  "2018-04-18": 1.78,
  "2018-04-19": 1.79,
  "2018-04-20": 1.78,
  "2018-04-23": 1.84,
  "2018-04-24": 1.84,
  "2018-04-25": 1.82,
  "2018-04-26": 1.79,
  "2018-04-27": 1.78,
  "2018-04-30": 1.84,
  "2018-05-01": 1.82,
  "2018-05-02": 1.81,
  "2018-05-03": 1.8,
  "2018-05-04": 1.8,
  "2018-05-07": 1.83,
  "2018-05-08": 1.84,
  "2018-05-09": 1.85,
  "2018-05-10": 1.86,
  "2018-05-11": 1.88,
  "2018-05-14": 1.9,
  "2018-05-15": 1.89,
  "2018-05-16": 1.88,
  "2018-05-17": 1.88,
  "2018-05-18": 1.87,
  "2018-05-21": 1.9,
  "2018-05-22": 1.9,
  "2018-05-23": 1.88,
  "2018-05-24": 1.87,
  "2018-05-25": 1.86,
  "2018-05-29": 1.9,
  "2018-05-30": 1.9,
  "2018-05-31": 1.89,
  "2018-06-01": 1.88,
  "2018-06-04": 1.91,
  "2018-06-05": 1.91,
  "2018-06-06": 1.91,
  "2018-06-07": 1.9,
  "2018-06-08": 1.89,
  "2018-06-11": 1.91,
  "2018-06-12": 1.89,
  "2018-06-13": 1.9,
  "2018-06-14": 1.9,
  "2018-06-15": 1.9,
  "2018-06-18": 1.91,
  "2018-06-19": 1.91,
  "2018-06-20": 1.9,
  "2018-06-21": 1.9,
  "2018-06-22": 1.89,
  "2018-06-25": 1.9,
  "2018-06-26": 1.9,
  "2018-06-27": 1.89,
  "2018-06-28": 1.89,
  "2018-06-29": 1.89,
  "2018-07-02": 1.95,
  "2018-07-03": 1.94,
  "2018-07-05": 1.92,
  "2018-07-06": 1.93,
  "2018-07-09": 1.95,
  "2018-07-10": 1.95,
  "2018-07-11": 1.93,
  "2018-07-12": 1.94,
  "2018-07-13": 1.94,
  "2018-07-16": 1.98,
  "2018-07-17": 1.98,
  "2018-07-18": 1.96,
  "2018-07-19": 1.96,
  "2018-07-20": 1.95,
  "2018-07-23": 1.96,
  "2018-07-24": 1.98,
  "2018-07-25": 1.97,
  "2018-07-26": 1.95,
  "2018-07-27": 1.96,
  "2018-07-30": 2.01,
  "2018-07-31": 1.99,
  "2018-08-01": 1.99,
  "2018-08-02": 1.98,
  "2018-08-03": 1.97,
  "2018-08-06": 2.02,
  "2018-08-07": 2.02,
  "2018-08-08": 2.02,
  "2018-08-09": 2.02,
  "2018-08-10": 2.01,
  "2018-08-13": 2.03,
  "2018-08-14": 2.04,
  "2018-08-15": 2.03,
  "2018-08-16": 2.03,
  "2018-08-17": 2.01,
  "2018-08-20": 2.03,
  "2018-08-21": 2.04,
  "2018-08-22": 2.05,
  "2018-08-23": 2.04,
  "2018-08-24": 2.05,
  "2018-08-27": 2.08,
  "2018-08-28": 2.09,
  "2018-08-29": 2.09,
  "2018-08-30": 2.07,
  "2018-08-31": 2.07,
  "2018-09-04": 2.09,
  "2018-09-05": 2.1,
  "2018-09-06": 2.09,
  "2018-09-07": 2.1,
  "2018-09-10": 2.11,
  "2018-09-11": 2.11,
  "2018-09-12": 2.12,
  "2018-09-13": 2.11,
  "2018-09-14": 2.12,
  "2018-09-17": 2.13,
  "2018-09-18": 2.13,
  "2018-09-19": 2.12,
  "2018-09-20": 2.13,
  "2018-09-21": 2.14,
  "2018-09-24": 2.18,
  "2018-09-25": 2.17,
  "2018-09-26": 2.16,
  "2018-09-27": 2.14,
  "2018-09-28": 2.15,
  "2018-10-01": 2.19,
  "2018-10-02": 2.19,
  "2018-10-03": 2.19,
  "2018-10-04": 2.18,
  "2018-10-05": 2.18,
  "2018-10-09": 2.21,
  "2018-10-10": 2.23,
  "2018-10-11": 2.22,
  "2018-10-12": 2.23,
  "2018-10-15": 2.27,
  "2018-10-16": 2.26,
  "2018-10-17": 2.27,
  "2018-10-18": 2.27,
  "2018-10-19": 2.26,
  "2018-10-22": 2.3,
  "2018-10-23": 2.29,
  "2018-10-24": 2.29,
  "2018-10-25": 2.29,
  "2018-10-26": 2.28,
  "2018-10-29": 2.3,
  "2018-10-30": 2.29,
  "2018-10-31": 2.29,
  "2018-11-01": 2.27,
  "2018-11-02": 2.28,
  "2018-11-05": 2.32,
  "2018-11-06": 2.31,
  "2018-11-07": 2.32,
  "2018-11-08": 2.3,
  "2018-11-09": 2.31,
  "2018-11-13": 2.34,
  "2018-11-14": 2.33,
  "2018-11-15": 2.32,
  "2018-11-16": 2.31,
  "2018-11-19": 2.34,
  "2018-11-20": 2.34,
  "2018-11-21": 2.36,
  "2018-11-23": 2.36,
  "2018-11-26": 2.37,
  "2018-11-27": 2.36,
  "2018-11-28": 2.35,
  "2018-11-29": 2.32,
  "2018-11-30": 2.32,
  "2018-12-03": 2.34,
  "2018-12-04": 2.38,
  "2018-12-06": 2.36,
  "2018-12-07": 2.35,
  "2018-12-10": 2.37,
  "2018-12-11": 2.37,
  "2018-12-12": 2.39,
  "2018-12-13": 2.38,
  "2018-12-14": 2.37,
  "2018-12-17": 2.36,
  "2018-12-18": 2.34,
  "2018-12-19": 2.35,
  "2018-12-20": 2.34,
  "2018-12-21": 2.34,
  "2018-12-24": 2.41,
  "2018-12-26": 2.39,
  "2018-12-27": 2.36,
  "2018-12-28": 2.35,
  "2018-12-31": 2.4,
  "2019-01-02": 2.37,
  "2019-01-03": 2.36,
  "2019-01-04": 2.37,
  "2019-01-07": 2.41,
  "2019-01-08": 2.41,
  "2019-01-09": 2.4,
  "2019-01-10": 2.38,
  "2019-01-11": 2.38,
  "2019-01-14": 2.4,
  "2019-01-15": 2.4,
  "2019-01-16": 2.38,
  "2019-01-17": 2.37,
  "2019-01-18": 2.36,
  "2019-01-22": 2.38,
  "2019-01-23": 2.36,
  "2019-01-24": 2.32,
  "2019-01-25": 2.34,
  "2019-01-28": 2.37,
  "2019-01-29": 2.37,
  "2019-01-30": 2.37,
  "2019-01-31": 2.36,
  "2019-02-01": 2.35,
  "2019-02-04": 2.37,
  "2019-02-05": 2.37,
  "2019-02-06": 2.37,
  "2019-02-07": 2.37,
  "2019-02-08": 2.38,
  "2019-02-11": 2.4,
  "2019-02-12": 2.38,
  "2019-02-13": 2.39,
  "2019-02-14": 2.38,
  "2019-02-15": 2.38,
  "2019-02-19": 2.41,
  "2019-02-20": 2.4,
  "2019-02-21": 2.4,
  "2019-02-22": 2.41,
  "2019-02-25": 2.42,
  "2019-02-26": 2.4,
  "2019-02-27": 2.4,
  "2019-02-28": 2.4,
  "2019-03-01": 2.39,
  "2019-03-04": 2.41,
  "2019-03-05": 2.41,
  "2019-03-06": 2.41,
  "2019-03-07": 2.4,
  "2019-03-08": 2.41,
  "2019-03-11": 2.41,
  "2019-03-12": 2.41,
  "2019-03-13": 2.4,
  "2019-03-14": 2.4,
  "2019-03-15": 2.4,
  "2019-03-18": 2.39,
  "2019-03-19": 2.41,
  "2019-03-20": 2.42,
  "2019-03-21": 2.43,
  "2019-03-22": 2.41,
  "2019-03-25": 2.41,
  "2019-03-26": 2.41,
  "2019-03-27": 2.39,
  "2019-03-28": 2.38,
  "2019-03-29": 2.35,
  "2019-04-01": 2.38,
  "2019-04-02": 2.37,
  "2019-04-03": 2.39,
  "2019-04-04": 2.39,
  "2019-04-05": 2.39,
  "2019-04-08": 2.38,
  "2019-04-09": 2.37,
  "2019-04-10": 2.38,
  "2019-04-11": 2.38,
  "2019-04-12": 2.39,
  "2019-04-15": 2.38,
  "2019-04-16": 2.38,
  "2019-04-17": 2.39,
  "2019-04-18": 2.37,
  "2019-04-22": 2.39,
  "2019-04-23": 2.4,
  "2019-04-24": 2.39,
  "2019-04-25": 2.38,
  "2019-04-26": 2.37,
  "2019-04-29": 2.39,
  "2019-04-30": 2.38,
  "2019-05-01": 2.38,
  "2019-05-02": 2.41,
  "2019-05-03": 2.38,
  "2019-05-06": 2.39,
  "2019-05-07": 2.38,
  "2019-05-08": 2.38,
  "2019-05-09": 2.38,
  "2019-05-10": 2.38,
  "2019-05-13": 2.36,
  "2019-05-14": 2.36,
  "2019-05-15": 2.37,
  "2019-05-16": 2.35,
  "2019-05-17": 2.34,
  "2019-05-20": 2.34,
  "2019-05-21": 2.34,
  "2019-05-22": 2.33,
  "2019-05-23": 2.32,
  "2019-05-24": 2.3,
  "2019-05-28": 2.32,
  "2019-05-29": 2.32,
  "2019-05-30": 2.33,
  "2019-05-31": 2.3,
  "2019-06-03": 2.3,
  "2019-06-04": 2.3,
  "2019-06-05": 2.3,
  "2019-06-06": 2.28,
  "2019-06-07": 2.23,
  "2019-06-10": 2.24,
  "2019-06-11": 2.22,
  "2019-06-12": 2.19,
  "2019-06-13": 2.14,
  "2019-06-14": 2.15,
  "2019-06-17": 2.18,
  "2019-06-18": 2.17,
  "2019-06-19": 2.13,
  "2019-06-20": 2.09,
  "2019-06-21": 2.07,
  "2019-06-24": 2.08,
  "2019-06-25": 2.07,
  "2019-06-26": 2.1,
  "2019-06-27": 2.09,
  "2019-06-28": 2.08,
  "2019-07-01": 2.16,
  "2019-07-02": 2.15,
  "2019-07-03": 2.16,
  "2019-07-05": 2.18,
  "2019-07-08": 2.21,
  "2019-07-09": 2.21,
  "2019-07-10": 2.15,
  "2019-07-11": 2.12,
  "2019-07-12": 2.1,
  "2019-07-15": 2.11,
  "2019-07-16": 2.1,
  "2019-07-17": 2.09,
  "2019-07-18": 2.01,
  "2019-07-19": 2.02,
  "2019-07-22": 2.04,
  "2019-07-23": 2.02,
  "2019-07-24": 2.05,
  "2019-07-25": 2.06,
  "2019-07-26": 2.08,
  "2019-07-29": 2.07,
  "2019-07-30": 2.04,
  "2019-07-31": 2.04,
  "2019-08-01": 2.03,
  "2019-08-02": 2.02,
  "2019-08-05": 2.0,
  "2019-08-06": 2.01,
  "2019-08-07": 1.98,
  "2019-08-08": 1.98,
  "2019-08-09": 1.96,
  "2019-08-12": 1.96,
  "2019-08-13": 1.96,
  "2019-08-14": 1.92,
  "2019-08-15": 1.87,
  "2019-08-16": 1.83,
  "2019-08-19": 1.9,
  "2019-08-20": 1.9,
  "2019-08-21": 1.93,
  "2019-08-22": 1.96,
  "2019-08-23": 1.93,
  "2019-08-26": 1.96,
  "2019-08-27": 1.94,
  "2019-08-28": 1.95,
  "2019-08-29": 1.95,
  "2019-08-30": 1.95,
  "2019-09-03": 1.94,
  "2019-09-04": 1.93,
  "2019-09-05": 1.93,
  "2019-09-06": 1.92,
  "2019-09-09": 1.92,
  "2019-09-10": 1.91,
  "2019-09-11": 1.92,
  "2019-09-12": 1.91,
  "2019-09-13": 1.92,
  "2019-09-16": 1.95,
  "2019-09-17": 1.95,
  "2019-09-18": 1.91,
  "2019-09-19": 1.89,
  "2019-09-20": 1.87,
  "2019-09-23": 1.9,
  "2019-09-24": 1.88,
  "2019-09-25": 1.85,
  "2019-09-26": 1.79,
  "2019-09-27": 1.76,
  "2019-09-30": 1.84,
  "2019-10-01": 1.78,
  "2019-10-02": 1.75,
  "2019-10-03": 1.67,
  "2019-10-04": 1.68,
  "2019-10-07": 1.71,
  "2019-10-08": 1.68,
  "2019-10-09": 1.66,
  "2019-10-10": 1.65,
  "2019-10-11": 1.65,
  "2019-10-15": 1.64,
  "2019-10-16": 1.63,
  "2019-10-17": 1.63,
  "2019-10-18": 1.63,
  "2019-10-21": 1.64,
  "2019-10-22": 1.62,
  "2019-10-23": 1.62,
  "2019-10-24": 1.64,
  "2019-10-25": 1.63,
  "2019-10-28": 1.62,
  "2019-10-29": 1.6,
  "2019-10-30": 1.59,
  "2019-10-31": 1.51,
  "2019-11-01": 1.49,
  "2019-11-04": 1.5,
  "2019-11-05": 1.53,
  "2019-11-06": 1.53,
  "2019-11-07": 1.53,
  "2019-11-08": 1.52,
  "2019-11-12": 1.56,
  "2019-11-13": 1.54,
  "2019-11-14": 1.54,
  "2019-11-15": 1.54,
  "2019-11-18": 1.54,
  "2019-11-19": 1.54,
  "2019-11-20": 1.54,
  "2019-11-21": 1.55,
  "2019-11-22": 1.55,
  "2019-11-25": 1.58,
  "2019-11-26": 1.57,
  "2019-11-27": 1.59,
  "2019-11-29": 1.56,
  "2019-12-02": 1.57,
  "2019-12-03": 1.54,
  "2019-12-04": 1.52,
  "2019-12-05": 1.51,
  "2019-12-06": 1.5,
  "2019-12-09": 1.51,
  "2019-12-10": 1.53,
  "2019-12-11": 1.54,
  "2019-12-12": 1.53,
  "2019-12-13": 1.54,
  "2019-12-16": 1.54,
  "2019-12-17": 1.53,
  "2019-12-18": 1.53,
  "2019-12-19": 1.54,
  "2019-12-20": 1.55,
  "2019-12-23": 1.56,
  "2019-12-24": 1.55,
  "2019-12-26": 1.55,
  "2019-12-27": 1.54,
  "2019-12-30": 1.54,
  "2019-12-31": 1.52,
  "2020-01-02": 1.51,
  "2020-01-03": 1.49,
  "2020-01-06": 1.53,
  "2020-01-07": 1.51,
  "2020-01-08": 1.51,
  "2020-01-09": 1.51,
  "2020-01-10": 1.51,
  "2020-01-13": 1.54,
  "2020-01-14": 1.54,
  "2020-01-15": 1.54,
  "2020-01-16": 1.52,
  "2020-01-17": 1.53,
  "2020-01-21": 1.53,
  "2020-01-22": 1.52,
  "2020-01-23": 1.52,
  "2020-01-24": 1.51,
  "2020-01-27": 1.52,
  "2020-01-28": 1.54,
  "2020-01-29": 1.53,
  "2020-01-30": 1.54,
  "2020-01-31": 1.52,
  "2020-02-03": 1.54,
  "2020-02-04": 1.54,
  "2020-02-05": 1.54,
  "2020-02-06": 1.54,
  "2020-02-07": 1.53,
  "2020-02-10": 1.55,
  "2020-02-11": 1.54,
  "2020-02-12": 1.55,
  "2020-02-13": 1.56,
  "2020-02-14": 1.55,
  "2020-02-18": 1.55,
  "2020-02-19": 1.55,
  "2020-02-20": 1.55,
  "2020-02-21": 1.53,
  "2020-02-24": 1.5,
  "2020-02-25": 1.5,
  "2020-02-26": 1.5,
  "2020-02-27": 1.42,
  "2020-02-28": 1.25,
  "2020-03-02": 1.1,
  "2020-03-03": 0.93,
  "2020-03-04": 0.71,
  "2020-03-05": 0.61,
  "2020-03-06": 0.45,
  "2020-03-09": 0.32,
  "2020-03-10": 0.43,
  "2020-03-11": 0.41,
  "2020-03-12": 0.33,
  "2020-03-13": 0.27,
  "2020-03-16": 0.24,
  "2020-03-17": 0.19,
  "2020-03-18": 0.02,
  "2020-03-19": 0.04,
  "2020-03-20": 0.05,
  "2020-03-23": 0.02,
  "2020-03-24": 0.01,
  "2020-03-25": -0.04,
  "2020-03-26": -0.05,
  "2020-03-27": 0.03,
  "2020-03-30": 0.12,
  "2020-03-31": 0.11,
  "2020-04-01": 0.09,
  "2020-04-02": 0.09,
  "2020-04-03": 0.1,
  "2020-04-06": 0.15,
  "2020-04-07": 0.14,
  "2020-04-08": 0.22,
  "2020-04-09": 0.25,
  "2020-04-13": 0.26,
  "2020-04-14": 0.2,
  "2020-04-15": 0.14,
  "2020-04-16": 0.14,
  "2020-04-17": 0.12,
  "2020-04-20": 0.12,
  "2020-04-21": 0.11,
  "2020-04-22": 0.12,
  "2020-04-23": 0.11,
  "2020-04-24": 0.12,
  "2020-04-27": 0.12,
  "2020-04-28": 0.11,
  "2020-04-29": 0.1,
  "2020-04-30": 0.09,
  "2020-05-01": 0.12,
  "2020-05-04": 0.13,
  "2020-05-05": 0.13,
  "2020-05-06": 0.12,
  "2020-05-07": 0.11,
  "2020-05-08": 0.12,
  "2020-05-11": 0.12,
  "2020-05-12": 0.13,
  "2020-05-13": 0.13,
  "2020-05-14": 0.12,
  "2020-05-15": 0.12,
  "2020-05-18": 0.13,
  "2020-05-19": 0.13,
  "2020-05-20": 0.12,
  "2020-05-21": 0.12,
  "2020-05-22": 0.12,
  "2020-05-26": 0.14,
  "2020-05-27": 0.15,
  "2020-05-28": 0.15,
  "2020-05-29": 0.14,
  "2020-06-01": 0.14,
  "2020-06-02": 0.15,
  "2020-06-03": 0.16,
  "2020-06-04": 0.15,
  "2020-06-05": 0.15,
  "2020-06-08": 0.17,
  "2020-06-09": 0.19,
  "2020-06-10": 0.17,
  "2020-06-11": 0.17,
  "2020-06-12": 0.16,
  "2020-06-15": 0.18,
  "2020-06-16": 0.17,
  "2020-06-17": 0.17,
  "2020-06-18": 0.16,
  "2020-06-19": 0.15,
  "2020-06-22": 0.16,
  "2020-06-23": 0.16,
  "2020-06-24": 0.15,
  "2020-06-25": 0.16,
  "2020-06-26": 0.14,
  "2020-06-29": 0.14,
  "2020-06-30": 0.16,
  "2020-07-01": 0.14,
  "2020-07-02": 0.14,
  "2020-07-06": 0.15,
  "2020-07-07": 0.15,
  "2020-07-08": 0.15,
  "2020-07-09": 0.13,
  "2020-07-10": 0.13,
  "2020-07-13": 0.14,
  "2020-07-14": 0.15,
  "2020-07-15": 0.16,
  "2020-07-16": 0.11,
  "2020-07-17": 0.11,
  "2020-07-20": 0.13,
  "2020-07-21": 0.13,
  "2020-07-22": 0.13,
  "2020-07-23": 0.12,
  "2020-07-24": 0.11,
  "2020-07-27": 0.11,
  "2020-07-28": 0.11,
  "2020-07-29": 0.11,
  "2020-07-30": 0.09,
  "2020-07-31": 0.09,
  "2020-08-03": 0.1,
  "2020-08-04": 0.09,
  "2020-08-05": 0.1,
  "2020-08-06": 0.1,
  "2020-08-07": 0.1,
  "2020-08-10": 0.11,
  "2020-08-11": 0.11,
  "2020-08-12": 0.11,
  "2020-08-13": 0.1,
  "2020-08-14": 0.1,
  "2020-08-17": 0.1,
  "2020-08-18": 0.09,
  "2020-08-19": 0.11,
  "2020-08-20": 0.11,
  "2020-08-21": 0.1,
  "2020-08-24": 0.12,
  "2020-08-25": 0.11,
  "2020-08-26": 0.11,
  "2020-08-27": 0.11,
  "2020-08-28": 0.1,
  "2020-08-31": 0.11,
  "2020-09-01": 0.12,
  "2020-09-02": 0.12,
  "2020-09-03": 0.11,
  "2020-09-04": 0.11,
  "2020-09-08": 0.13,
  "2020-09-09": 0.12,
  "2020-09-10": 0.12,
  "2020-09-11": 0.11,
  "2020-09-14": 0.11,
  "2020-09-15": 0.11,
  "2020-09-16": 0.12,
  "2020-09-17": 0.09,
  "2020-09-18": 0.1,
  "2020-09-21": 0.1,
  "2020-09-22": 0.1,
  "2020-09-23": 0.11,
  "2020-09-24": 0.1,
  "2020-09-25": 0.1,
  "2020-09-28": 0.11,
  "2020-09-29": 0.09,
  "2020-09-30": 0.1,
  "2020-10-01": 0.09,
  "2020-10-02": 0.09,
  "2020-10-05": 0.1,
  "2020-10-06": 0.1,
  "2020-10-07": 0.1,
  "2020-10-08": 0.09,
  "2020-10-09": 0.1,
  "2020-10-13": 0.11,
  "2020-10-14": 0.12,
  "2020-10-15": 0.11,
  "2020-10-16": 0.11,
  "2020-10-19": 0.11,
  "2020-10-20": 0.1,
  "2020-10-21": 0.1,
  "2020-10-22": 0.09,
  "2020-10-23": 0.1,
  "2020-10-26": 0.11,
  "2020-10-27": 0.1,
  "2020-10-28": 0.1,
  "2020-10-29": 0.09,
  "2020-10-30": 0.09,
  "2020-11-02": 0.09,
  "2020-11-03": 0.1,
  "2020-11-04": 0.1,
  "2020-11-05": 0.1,
  "2020-11-06": 0.1,
  "2020-11-09": 0.11,
  "2020-11-10": 0.1,
  "2020-11-12": 0.1,
  "2020-11-13": 0.09,
  "2020-11-16": 0.09,
  "2020-11-17": 0.09,
  "2020-11-18": 0.09,
  "2020-11-19": 0.07,
  "2020-11-20": 0.07,
  "2020-11-23": 0.08,
  "2020-11-24": 0.09,
  "2020-11-25": 0.09,
  "2020-11-27": 0.09,
  "2020-11-30": 0.08,
  "2020-12-01": 0.09,
  "2020-12-02": 0.09,
  "2020-12-03": 0.08,
  "2020-12-04": 0.09,
  "2020-12-07": 0.08,
  "2020-12-08": 0.09,
  "2020-12-09": 0.08,
  "2020-12-10": 0.08,
  "2020-12-11": 0.08,
  "2020-12-14": 0.09,
  "2020-12-15": 0.08,
  "2020-12-16": 0.09,
  "2020-12-17": 0.08,
  "2020-12-18": 0.08,
  "2020-12-21": 0.09,
  "2020-12-22": 0.09,
  "2020-12-23": 0.09,
  "2020-12-24": 0.09,
  "2020-12-28": 0.11,
  "2020-12-29": 0.1,
  "2020-12-30": 0.08,
  "2020-12-31": 0.09,
  "2021-01-04": 0.09,
  "2021-01-05": 0.09,
  "2021-01-06": 0.09,
  "2021-01-07": 0.09,
  "2021-01-08": 0.08,
  "2021-01-11": 0.08,
  "2021-01-12": 0.09,
  "2021-01-13": 0.09,
  "2021-01-14": 0.09,
  "2021-01-15": 0.09,
  "2021-01-19": 0.09,
  "2021-01-20": 0.08,
  "2021-01-21": 0.09,
  "2021-01-22": 0.08,
  "2021-01-25": 0.09,
  "2021-01-26": 0.07,
  "2021-01-27": 0.08,
  "2021-01-28": 0.07,
  "2021-01-29": 0.06,
  "2021-02-01": 0.07,
  "2021-02-02": 0.07,
  "2021-02-03": 0.04,
  "2021-02-04": 0.04,
  "2021-02-05": 0.03,
  "2021-02-08": 0.05,
  "2021-02-09": 0.04,
  "2021-02-10": 0.05,
  "2021-02-11": 0.05,
  "2021-02-12": 0.04,
  "2021-02-16": 0.04,
  "2021-02-17": 0.04,
  "2021-02-18": 0.03,
  "2021-02-19": 0.04,
  "2021-02-22": 0.03,
  "2021-02-23": 0.04,
  "2021-02-24": 0.03,
  "2021-02-25": 0.04,
  "2021-02-26": 0.04,
  "2021-03-01": 0.05,
  "2021-03-02": 0.04,
  "2021-03-03": 0.05,
  "2021-03-04": 0.04,
  "2021-03-05": 0.04,
  "2021-03-08": 0.05,
  "2021-03-09": 0.05,
  "2021-03-10": 0.04,
  "2021-03-11": 0.04,
  "2021-03-12": 0.04,
  "2021-03-15": 0.04,
  "2021-03-16": 0.02,
  "2021-03-17": 0.02,
  "2021-03-18": 0.01,
  "2021-03-19": 0.01,
  "2021-03-22": 0.03,
  "2021-03-23": 0.01,
  "2021-03-24": 0.02,
  "2021-03-25": 0.02,
  "2021-03-26": 0.02,
  "2021-03-29": 0.03,
  "2021-03-30": 0.02,
  "2021-03-31": 0.03,
  "2021-04-01": 0.02,
  "2021-04-02": 0.02,
  "2021-04-05": 0.03,
  "2021-04-06": 0.02,
  "2021-04-07": 0.02,
  "2021-04-08": 0.01,
  "2021-04-09": 0.02,
  "2021-04-12": 0.02,
  "2021-04-13": 0.03,
  "2021-04-14": 0.02,
  "2021-04-15": 0.02,
  "2021-04-16": 0.02,
  "2021-04-19": 0.02,
  "2021-04-20": 0.03,
  "2021-04-21": 0.03,
  "2021-04-22": 0.03,
  "2021-04-23": 0.03,
  "2021-04-26": 0.03,
  "2021-04-27": 0.01,
  "2021-04-28": 0.01,
  "2021-04-29": 0.01,
  "2021-04-30": 0.01,
  "2021-05-03": 0.04,
  "2021-05-04": 0.02,
  "2021-05-05": 0.02,
  "2021-05-06": 0.02,
  "2021-05-07": 0.02,
  "2021-05-10": 0.02,
  "2021-05-11": 0.01,
  "2021-05-12": 0.02,
  "2021-05-13": 0.02,
  "2021-05-14": 0.01,
  "2021-05-17": 0.02,
  "2021-05-18": 0.02,
  "2021-05-19": 0.01,
  "2021-05-20": 0.01,
  "2021-05-21": 0.01,
  "2021-05-24": 0.02,
  "2021-05-25": 0.02,
  "2021-05-26": 0.02,
  "2021-05-27": 0.02,
  "2021-05-28": 0.01,
  "2021-06-01": 0.02,
  "2021-06-02": 0.02,
  "2021-06-03": 0.02,
  "2021-06-04": 0.02,
  "2021-06-07": 0.02,
  "2021-06-08": 0.02,
  "2021-06-09": 0.03,
  "2021-06-10": 0.03,
  "2021-06-11": 0.03,
  "2021-06-14": 0.03,
  "2021-06-15": 0.03,
  "2021-06-16": 0.04,
  "2021-06-17": 0.04,
  "2021-06-18": 0.05,
  "2021-06-21": 0.05,
  "2021-06-22": 0.04,
  "2021-06-23": 0.05,
  "2021-06-24": 0.05,
  "2021-06-25": 0.06,
  "2021-06-28": 0.05,
  "2021-06-29": 0.04,
  "2021-06-30": 0.05,
  "2021-07-01": 0.05,
  "2021-07-02": 0.05,
  "2021-07-06": 0.05,
  "2021-07-07": 0.05,
  "2021-07-08": 0.06,
  "2021-07-09": 0.06,
  "2021-07-12": 0.05,
  "2021-07-13": 0.05,
  "2021-07-14": 0.06,
  "2021-07-15": 0.05,
  "2021-07-16": 0.05,
  "2021-07-19": 0.05,
  "2021-07-20": 0.05,
  "2021-07-21": 0.05,
  "2021-07-22": 0.05,
  "2021-07-23": 0.05,
  "2021-07-26": 0.05,
  "2021-07-27": 0.05,
  "2021-07-28": 0.05,
  "2021-07-29": 0.06,
  "2021-07-30": 0.06,
  "2021-08-02": 0.05,
  "2021-08-03": 0.05,
  "2021-08-04": 0.05,
  "2021-08-05": 0.05,
  "2021-08-06": 0.06,
  "2021-08-09": 0.06,
  "2021-08-10": 0.05,
  "2021-08-11": 0.05,
  "2021-08-12": 0.06,
  "2021-08-13": 0.06,
  "2021-08-16": 0.06,
  "2021-08-17": 0.07,
  "2021-08-18": 0.07,
  "2021-08-19": 0.06,
  "2021-08-20": 0.05,
  "2021-08-23": 0.05,
  "2021-08-24": 0.05,
  "2021-08-25": 0.06,
  "2021-08-26": 0.05,
  "2021-08-27": 0.05,
  "2021-08-30": 0.05,
  "2021-08-31": 0.04,
  "2021-09-01": 0.05,
  "2021-09-02": 0.05,
  "2021-09-03": 0.05,
  "2021-09-07": 0.05,
  "2021-09-08": 0.05,
  "2021-09-09": 0.04,
  "2021-09-10": 0.05,
  "2021-09-13": 0.06,
  "2021-09-14": 0.04,
  "2021-09-15": 0.04,
  "2021-09-16": 0.04,
  "2021-09-17": 0.04,
  "2021-09-20": 0.04,
  "2021-09-21": 0.03,
  "2021-09-22": 0.03,
  "2021-09-23": 0.03,
  "2021-09-24": 0.03,
  "2021-09-27": 0.04,
  "2021-09-28": 0.04,
  "2021-09-29": 0.04,
  "2021-09-30": 0.04,
  "2021-10-01": 0.04,
  "2021-10-04": 0.04,
  "2021-10-05": 0.04,
  "2021-10-06": 0.04,
  "2021-10-07": 0.05,
  "2021-10-08": 0.05,
  "2021-10-12": 0.06,
  "2021-10-13": 0.05,
  "2021-10-14": 0.05,
  "2021-10-15": 0.05,
  "2021-10-18": 0.06,
  "2021-10-19": 0.05,
  "2021-10-20": 0.05,
  "2021-10-21": 0.06,
  "2021-10-22": 0.06,
  "2021-10-25": 0.06,
  "2021-10-26": 0.06,
  "2021-10-27": 0.06,
  "2021-10-28": 0.06,
  "2021-10-29": 0.05,
  "2021-11-01": 0.05,
  "2021-11-02": 0.05,
  "2021-11-03": 0.05,
  "2021-11-04": 0.04,
  "2021-11-05": 0.05,
  "2021-11-08": 0.06,
  "2021-11-09": 0.04,
  "2021-11-10": 0.05,
  "2021-11-12": 0.05,
  "2021-11-15": 0.05,
  "2021-11-16": 0.05,
  "2021-11-17": 0.05,
  "2021-11-18": 0.05,
  "2021-11-19": 0.05,
  "2021-11-22": 0.05,
  "2021-11-23": 0.06,
  "2021-11-24": 0.06,
  "2021-11-26": 0.06,
  "2021-11-29": 0.06,
  "2021-11-30": 0.05,
  "2021-12-01": 0.06,
  "2021-12-02": 0.05,
  "2021-12-03": 0.06,
  "2021-12-06": 0.06,
  "2021-12-07": 0.06,
  "2021-12-08": 0.07,
  "2021-12-09": 0.06,
  "2021-12-10": 0.06,
  "2021-12-13": 0.05,
  "2021-12-14": 0.05,
  "2021-12-15": 0.06,
  "2021-12-16": 0.05,
  "2021-12-17": 0.05,
  "2021-12-20": 0.07,
  "2021-12-21": 0.07,
  "2021-12-22": 0.08,
  "2021-12-23": 0.08,
  "2021-12-27": 0.06,
  "2021-12-28": 0.06,
  "2021-12-29": 0.05,
  "2021-12-30": 0.05,
  "2021-12-31": 0.06,
  "2022-01-03": 0.09,
  "2022-01-04": 0.08,
  "2022-01-05": 0.09,
  "2022-01-06": 0.1,
  "2022-01-07": 0.1,
  "2022-01-10": 0.13,
  "2022-01-11": 0.12,
  "2022-01-12": 0.12,
  "2022-01-13": 0.12,
  "2022-01-14": 0.13,
  "2022-01-18": 0.17,
  "2022-01-19": 0.17,
  "2022-01-20": 0.18,
  "2022-01-21": 0.17,
  "2022-01-24": 0.2,
  "2022-01-25": 0.2,
  "2022-01-26": 0.19,
  "2022-01-27": 0.2,
  "2022-01-28": 0.19,
  "2022-01-31": 0.24,
  "2022-02-01": 0.2,
  "2022-02-02": 0.2,
  "2022-02-03": 0.21,
  "2022-02-04": 0.23,
  "2022-02-07": 0.28,
  "2022-02-08": 0.27,
  "2022-02-09": 0.27,
  "2022-02-10": 0.41,
  "2022-02-11": 0.37,
  "2022-02-14": 0.45,
  "2022-02-15": 0.41,
  "2022-02-16": 0.39,
  "2022-02-17": 0.37,
  "2022-02-18": 0.35,
  "2022-02-22": 0.39,
  "2022-02-23": 0.36,
  "2022-02-24": 0.33,
  "2022-02-25": 0.33,
  "2022-02-28": 0.37,
  "2022-03-01": 0.32,
  "2022-03-02": 0.33,
  "2022-03-03": 0.37,
  "2022-03-04": 0.33,
  "2022-03-07": 0.38,
  "2022-03-08": 0.36,
  "2022-03-09": 0.38,
  "2022-03-10": 0.38,
  "2022-03-11": 0.39,
  "2022-03-14": 0.45,
  "2022-03-15": 0.46,
  "2022-03-16": 0.43,
  "2022-03-17": 0.4,
  "2022-03-18": 0.41,
  "2022-03-21": 0.55,
  "2022-03-22": 0.51,
  "2022-03-23": 0.5,
  "2022-03-24": 0.5,
  "2022-03-25": 0.53,
  "2022-03-28": 0.6,
  "2022-03-29": 0.56,
  "2022-03-30": 0.55,
  "2022-03-31": 0.51,
  "2022-04-01": 0.52,
  "2022-04-04": 0.67,
  "2022-04-05": 0.65,
  "2022-04-06": 0.67,
  "2022-04-07": 0.68,
  "2022-04-08": 0.69,
  "2022-04-11": 0.78,
  "2022-04-12": 0.74,
  "2022-04-13": 0.75,
  "2022-04-14": 0.78,
  "2022-04-18": 0.82,
  "2022-04-19": 0.82,
  "2022-04-20": 0.82,
  "2022-04-21": 0.82,
  "2022-04-22": 0.82,
  "2022-04-25": 0.93,
  "2022-04-26": 0.84,
  "2022-04-27": 0.82,
  "2022-04-28": 0.81,
  "2022-04-29": 0.83,
  "2022-05-02": 0.9,
  "2022-05-03": 0.9,
  "2022-05-04": 0.88,
  "2022-05-05": 0.84,
  "2022-05-06": 0.84,
  "2022-05-09": 0.92,
  "2022-05-10": 0.89,
  "2022-05-11": 0.9,
  "2022-05-12": 0.95,
  "2022-05-13": 1.01,
  "2022-05-16": 1.07,
  "2022-05-17": 1.06,
  "2022-05-18": 1.02,
  "2022-05-19": 1.04,
  "2022-05-20": 1.01,
  "2022-05-23": 1.07,
  "2022-05-24": 1.05,
  "2022-05-25": 1.05,
  "2022-05-26": 1.06,
  "2022-05-27": 1.06,
  "2022-05-31": 1.13,
  "2022-06-01": 1.12,
  "2022-06-02": 1.13,
  "2022-06-03": 1.17,
  "2022-06-06": 1.23,
  "2022-06-07": 1.24,
  "2022-06-08": 1.25,
  "2022-06-09": 1.26,
  "2022-06-10": 1.34,
  "2022-06-13": 1.69,
  "2022-06-14": 1.78,
  "2022-06-15": 1.69,
  "2022-06-16": 1.54,
  "2022-06-17": 1.58,
  "2022-06-21": 1.66,
  "2022-06-22": 1.57,
  "2022-06-23": 1.59,
  "2022-06-24": 1.66,
  "2022-06-27": 1.75,
  "2022-06-28": 1.75,
  "2022-06-29": 1.73,
  "2022-06-30": 1.66,
  "2022-07-01": 1.66,
  "2022-07-05": 1.86,
  "2022-07-06": 1.85,
  "2022-07-07": 1.89,
  "2022-07-08": 1.91,
  "2022-07-11": 2.13,
  "2022-07-12": 2.16,
  "2022-07-13": 2.33,
  "2022-07-14": 2.33,
  "2022-07-15": 2.29,
  "2022-07-18": 2.44,
  "2022-07-19": 2.46,
  "2022-07-20": 2.44,
  "2022-07-21": 2.4,
  "2022-07-22": 2.41,
  "2022-07-25": 2.55,
  "2022-07-26": 2.48,
  "2022-07-27": 2.37,
  "2022-07-28": 2.35,
  "2022-07-29": 2.34,
  "2022-08-01": 2.48,
  "2022-08-02": 2.48,
  "2022-08-03": 2.44,
  "2022-08-04": 2.41,
  "2022-08-05": 2.48,
  "2022-08-08": 2.57,
  "2022-08-09": 2.58,
  "2022-08-10": 2.56,
  "2022-08-11": 2.52,
  "2022-08-12": 2.53,
  "2022-08-15": 2.63,
  "2022-08-16": 2.61,
  "2022-08-17": 2.59,
  "2022-08-18": 2.61,
  "2022-08-19": 2.64,
  "2022-08-22": 2.74,
  "2022-08-23": 2.71,
  "2022-08-24": 2.73,
  "2022-08-25": 2.78,
  "2022-08-26": 2.78,
  "2022-08-29": 2.89,
  "2022-08-30": 2.88,
  "2022-08-31": 2.87,
  "2022-09-01": 2.88,
  "2022-09-02": 2.85,
  "2022-09-06": 2.96,
  "2022-09-07": 2.98,
  "2022-09-08": 2.97,
  "2022-09-09": 2.98,
  "2022-09-12": 3.09,
  "2022-09-13": 3.19,
  "2022-09-14": 3.14,
  "2022-09-15": 3.12,
  "2022-09-16": 3.1,
  "2022-09-19": 3.29,
  "2022-09-20": 3.26,
  "2022-09-21": 3.21,
  "2022-09-22": 3.19,
  "2022-09-23": 3.12,
  "2022-09-26": 3.3,
  "2022-09-27": 3.26,
  "2022-09-28": 3.29,
  "2022-09-29": 3.26,
  "2022-09-30": 3.22,
  "2022-10-03": 3.34,
  "2022-10-04": 3.32,
  "2022-10-05": 3.33,
  "2022-10-06": 3.32,
  "2022-10-07": 3.31,
  "2022-10-11": 3.53,
  "2022-10-12": 3.56,
  "2022-10-13": 3.64,
  "2022-10-14": 3.65,
  "2022-10-17": 3.82,
  "2022-10-18": 3.89,
  "2022-10-19": 3.91,
  "2022-10-20": 3.91,
  "2022-10-21": 3.9,
  "2022-10-24": 4.0,
  "2022-10-25": 3.97,
  "2022-10-26": 3.94,
  "2022-10-27": 3.95,
  "2022-10-28": 3.99,
  "2022-10-31": 4.06,
  "2022-11-01": 4.06,
  "2022-11-02": 4.04,
  "2022-11-03": 4.06,
  "2022-11-04": 4.02,
  "2022-11-07": 4.12,
  "2022-11-08": 4.1,
  "2022-11-09": 4.11,
  "2022-11-10": 4.09,
  "2022-11-14": 4.16,
  "2022-11-15": 4.14,
  "2022-11-16": 4.14,
  "2022-11-17": 4.13,
  "2022-11-18": 4.15,
  "2022-11-21": 4.23,
  "2022-11-22": 4.21,
  "2022-11-23": 4.21,
  "2022-11-25": 4.22,
  "2022-11-28": 4.3,
  "2022-11-29": 4.27,
  "2022-11-30": 4.27,
  "2022-12-01": 4.22,
  "2022-12-02": 4.22,
  "2022-12-05": 4.27,
  "2022-12-06": 4.27,
  "2022-12-07": 4.2,
  "2022-12-08": 4.17,
  "2022-12-09": 4.19,
  "2022-12-12": 4.29,
  "2022-12-13": 4.26,
  "2022-12-14": 4.23,
  "2022-12-15": 4.22,
  "2022-12-16": 4.2,
  "2022-12-19": 4.28,
  "2022-12-20": 4.25,
  "2022-12-21": 4.22,
  "2022-12-22": 4.24,
  "2022-12-23": 4.23,
  "2022-12-27": 4.35,
  "2022-12-28": 4.35,
  "2022-12-29": 4.34,
  "2022-12-30": 4.3,
  "2023-01-03": 4.4,
  "2023-01-04": 4.41,
  "2023-01-05": 4.51,
  "2023-01-06": 4.51,
  "2023-01-09": 4.55,
  "2023-01-10": 4.57,
  "2023-01-11": 4.57,
  "2023-01-12": 4.5,
  "2023-01-13": 4.51,
  "2023-01-17": 4.56,
  "2023-01-18": 4.54,
  "2023-01-19": 4.55,
  "2023-01-20": 4.57,
  "2023-01-23": 4.58,
  "2023-01-24": 4.57,
  "2023-01-25": 4.56,
  "2023-01-26": 4.55,
  "2023-01-27": 4.57,
  "2023-01-30": 4.59,
  "2023-01-31": 4.58,
  "2023-02-01": 4.54,
  "2023-02-02": 4.53,
  "2023-02-03": 4.57,
  "2023-02-06": 4.59,
  "2023-02-07": 4.59,
  "2023-02-08": 4.59,
  "2023-02-09": 4.64,
  "2023-02-10": 4.66,
  "2023-02-13": 4.68,
  "2023-02-14": 4.67,
  "2023-02-15": 4.66,
  "2023-02-16": 4.7,
  "2023-02-17": 4.7,
  "2023-02-21": 4.72,
  "2023-02-22": 4.71,
  "2023-02-23": 4.71,
  "2023-02-24": 4.72,
  "2023-02-27": 4.74,
  "2023-02-28": 4.72,
  "2023-03-01": 4.73,
  "2023-03-02": 4.74,
  "2023-03-03": 4.74,
  "2023-03-06": 4.76,
  "2023-03-07": 4.87,
  "2023-03-08": 4.89,
  "2023-03-09": 4.87,
  "2023-03-10": 4.83,
  "2023-03-13": 4.7,
  "2023-03-14": 4.71,
  "2023-03-15": 4.59,
  "2023-03-16": 4.57,
  "2023-03-17": 4.36,
  "2023-03-20": 4.65,
  "2023-03-21": 4.62,
  "2023-03-22": 4.63,
  "2023-03-23": 4.57,
  "2023-03-24": 4.57,
  "2023-03-27": 4.75,
  "2023-03-28": 4.64,
  "2023-03-29": 4.64,
  "2023-03-30": 4.8,
  "2023-03-31": 4.68,
  "2023-04-03": 4.77,
  "2023-04-04": 4.74,
  "2023-04-05": 4.72,
  "2023-04-06": 4.77,
  "2023-04-07": 4.81,
  "2023-04-10": 4.94,
  "2023-04-11": 4.89,
  "2023-04-12": 4.87,
  "2023-04-13": 4.95,
  "2023-04-14": 4.98,
  "2023-04-17": 5.06,
  "2023-04-18": 5.04,
  "2023-04-19": 5.01,
  "2023-04-20": 4.97,
  "2023-04-21": 4.98,
  "2023-04-24": 5.04,
  "2023-04-25": 4.97,
  "2023-04-26": 5.0,
  "2023-04-27": 5.03,
  "2023-04-28": 4.95,
  "2023-05-01": 5.1,
  "2023-05-02": 5.08,
  "2023-05-03": 5.09,
  "2023-05-04": 5.1,
  "2023-05-05": 5.1,
  "2023-05-08": 5.15,
  "2023-05-09": 5.13,
  "2023-05-10": 5.08,
  "2023-05-11": 5.04,
  "2023-05-12": 5.08,
  "2023-05-15": 5.06,
  "2023-05-16": 5.07,
  "2023-05-17": 5.1,
  "2023-05-18": 5.14,
  "2023-05-19": 5.12,
  "2023-05-22": 5.24,
  "2023-05-23": 5.18,
  "2023-05-24": 5.21,
  "2023-05-25": 5.21,
  "2023-05-26": 5.16,
  "2023-05-30": 5.28,
  "2023-05-31": 5.26,
  "2023-06-01": 5.24,
  "2023-06-02": 5.23,
  "2023-06-05": 5.2,
  "2023-06-06": 5.18,
  "2023-06-07": 5.16,
  "2023-06-08": 5.12,
  "2023-06-09": 5.11,
  "2023-06-12": 5.14,
  "2023-06-13": 5.11,
  "2023-06-14": 5.1,
  "2023-06-15": 5.07,
  "2023-06-16": 5.09,
  "2023-06-20": 5.14,
  "2023-06-21": 5.15,
  "2023-06-22": 5.15,
  "2023-06-23": 5.15,
  "2023-06-26": 5.24,
  "2023-06-27": 5.19,
  "2023-06-28": 5.18,
  "2023-06-29": 5.2,
  "2023-06-30": 5.17,
  "2023-07-03": 5.21,
  "2023-07-05": 5.21,
  "2023-07-06": 5.23,
  "2023-07-07": 5.22,
  "2023-07-10": 5.25,
  "2023-07-11": 5.25,
  "2023-07-12": 5.24,
  "2023-07-13": 5.24,
  "2023-07-14": 5.25,
  "2023-07-17": 5.26,
  "2023-07-18": 5.25,
  "2023-07-19": 5.26,
  "2023-07-20": 5.26,
  "2023-07-21": 5.27,
  "2023-07-24": 5.28,
  "2023-07-25": 5.28,
  "2023-07-26": 5.28,
  "2023-07-27": 5.28,
  "2023-07-28": 5.28,
  "2023-07-31": 5.28,
  "2023-08-01": 5.27,
  "2023-08-02": 5.27,
  "2023-08-03": 5.27,
  "2023-08-04": 5.28,
  "2023-08-07": 5.29,
  "2023-08-08": 5.3,
  "2023-08-09": 5.28,
  "2023-08-10": 5.28,
  "2023-08-11": 5.28,
  "2023-08-14": 5.29,
  "2023-08-15": 5.29,
  "2023-08-16": 5.29,
  "2023-08-17": 5.29,
  "2023-08-18": 5.28,
  "2023-08-21": 5.3,
  "2023-08-22": 5.3,
  "2023-08-23": 5.3,
  "2023-08-24": 5.31,
  "2023-08-25": 5.34,
  "2023-08-28": 5.34,
  "2023-08-29": 5.33,
  "2023-08-30": 5.32,
  "2023-08-31": 5.32,
  "2023-09-01": 5.3,
  "2023-09-05": 5.32,
  "2023-09-06": 5.31,
  "2023-09-07": 5.3,
  "2023-09-08": 5.31,
  "2023-09-11": 5.32,
  "2023-09-12": 5.32,
  "2023-09-13": 5.31,
  "2023-09-14": 5.31,
  "2023-09-15": 5.32,
  "2023-09-18": 5.31,
  "2023-09-19": 5.31,
  "2023-09-20": 5.33,
  "2023-09-21": 5.33,
  "2023-09-22": 5.32,
  "2023-09-25": 5.35,
  "2023-09-26": 5.34,
  "2023-09-27": 5.34,
  "2023-09-28": 5.32,
  "2023-09-29": 5.32,
  "2023-10-02": 5.35,
  "2023-10-03": 5.35,
  "2023-10-04": 5.34,
  "2023-10-05": 5.34,
  "2023-10-06": 5.36,
  "2023-10-10": 5.34,
  "2023-10-11": 5.34,
  "2023-10-12": 5.35,
  "2023-10-13": 5.35,
  "2023-10-16": 5.34,
  "2023-10-17": 5.35,
  "2023-10-18": 5.34,
  "2023-10-19": 5.33,
  "2023-10-20": 5.31,
  "2023-10-23": 5.32,
  "2023-10-24": 5.31,
  "2023-10-25": 5.32,
  "2023-10-26": 5.32,
  "2023-10-27": 5.32,
  "2023-10-30": 5.33,
  "2023-10-31": 5.33,
  "2023-11-01": 5.31,
  "2023-11-02": 5.28,
  "2023-11-03": 5.27,
  "2023-11-06": 5.29,
  "2023-11-07": 5.28,
  "2023-11-08": 5.28,
  "2023-11-09": 5.27,
  "2023-11-10": 5.26,
  "2023-11-13": 5.28,
  "2023-11-14": 5.26,
  "2023-11-15": 5.26,
  "2023-11-16": 5.25,
  "2023-11-17": 5.25,
  "2023-11-20": 5.27,
  "2023-11-21": 5.26,
  "2023-11-22": 5.27,
  "2023-11-24": 5.28,
  "2023-11-27": 5.28,
  "2023-11-28": 5.27,
  "2023-11-29": 5.25,
  "2023-11-30": 5.25,
  "2023-12-01": 5.23,
  "2023-12-04": 5.26,
  "2023-12-05": 5.25,
  "2023-12-06": 5.25,
  "2023-12-07": 5.24,
  "2023-12-08": 5.24,
  "2023-12-11": 5.26,
  "2023-12-12": 5.26,
  "2023-12-13": 5.24,
  "2023-12-14": 5.23,
  "2023-12-15": 5.24,
  "2023-12-18": 5.26,
  "2023-12-19": 5.23,
  "2023-12-20": 5.24,
  "2023-12-21": 5.22,
  "2023-12-22": 5.24,
  "2023-12-26": 5.25,
  "2023-12-27": 5.24,
  "2023-12-28": 5.25,
  "2023-12-29": 5.2,
  "2024-01-02": 5.22,
  "2024-01-03": 5.24,
  "2024-01-04": 5.24,
  "2024-01-05": 5.24,
  "2024-01-08": 5.25,
  "2024-01-09": 5.24,
  "2024-01-10": 5.23,
  "2024-01-11": 5.23,
  "2024-01-12": 5.22,
  "2024-01-16": 5.22,
  "2024-01-17": 5.24,
  "2024-01-18": 5.22,
  "2024-01-19": 5.22,
  "2024-01-22": 5.22,
  "2024-01-23": 5.21,
  "2024-01-24": 5.21,
  "2024-01-25": 5.21,
  "2024-01-26": 5.21,
  "2024-01-29": 5.22,
  "2024-01-30": 5.21,
  "2024-01-31": 5.22,
  "2024-02-01": 5.22,
  "2024-02-02": 5.23,
  "2024-02-05": 5.22,
  "2024-02-06": 5.23,
  "2024-02-07": 5.23,
  "2024-02-08": 5.23,
  "2024-02-09": 5.24,
  "2024-02-12": 5.23,
  "2024-02-13": 5.25,
  "2024-02-14": 5.23,
  "2024-02-15": 5.23,
  "2024-02-16": 5.24,
  "2024-02-20": 5.24,
  "2024-02-21": 5.24,
  "2024-02-22": 5.25,
  "2024-02-23": 5.26,
  "2024-02-26": 5.26,
  "2024-02-27": 5.25,
  "2024-02-28": 5.24,
  "2024-02-29": 5.25,
  "2024-03-01": 5.23,
  "2024-03-04": 5.24,
  "2024-03-05": 5.23,
  "2024-03-06": 5.24,
  "2024-03-07": 5.24,
  "2024-03-08": 5.24,
  "2024-03-11": 5.24,
  "2024-03-12": 5.25,
  "2024-03-13": 5.25,
  "2024-03-14": 5.25,
  "2024-03-15": 5.25,
  "2024-03-18": 5.25,
  "2024-03-19": 5.24,
  "2024-03-20": 5.24,
  "2024-03-21": 5.25,
  "2024-03-22": 5.24,
  "2024-03-25": 5.23,
  "2024-03-26": 5.22,
  "2024-03-27": 5.22,
  "2024-03-28": 5.23,
  "2024-04-01": 5.23,
  "2024-04-02": 5.22,
  "2024-04-03": 5.22,
  "2024-04-04": 5.21,
  "2024-04-05": 5.23,
  "2024-04-08": 5.23,
  "2024-04-09": 5.23,
  "2024-04-10": 5.25,
  "2024-04-11": 5.25,
  "2024-04-12": 5.25,
  "2024-04-15": 5.25,
  "2024-04-16": 5.25,
  "2024-04-17": 5.25,
  "2024-04-18": 5.25,
  "2024-04-19": 5.25,
  "2024-04-22": 5.22,
  "2024-04-23": 5.25,
  "2024-04-24": 5.26,
  "2024-04-25": 5.26,
  "2024-04-26": 5.25,
  "2024-04-29": 5.25,
  "2024-04-30": 5.25,
  "2024-05-01": 5.26,
  "2024-05-02": 5.25,
  "2024-05-03": 5.25,
  "2024-05-06": 5.25,
  "2024-05-07": 5.25,
  "2024-05-08": 5.25,
  "2024-05-09": 5.25,
  "2024-05-10": 5.26,
  "2024-05-13": 5.25,
  "2024-05-14": 5.24,
  "2024-05-15": 5.25,
  "2024-05-16": 5.25,
  "2024-05-17": 5.25,
  "2024-05-20": 5.25,
  "2024-05-21": 5.25,
  "2024-05-22": 5.25,
  "2024-05-23": 5.26,
  "2024-05-24": 5.26,
  "2024-05-28": 5.26,
  "2024-05-29": 5.26,
  "2024-05-30": 5.26,
  "2024-05-31": 5.25,
  "2024-06-03": 5.26,
  "2024-06-04": 5.25,
  "2024-06-05": 5.25,
  "2024-06-06": 5.25,
  "2024-06-07": 5.26,
  "2024-06-10": 5.25,
  "2024-06-11": 5.25,
  "2024-06-12": 5.25,
  "2024-06-13": 5.25,
  "2024-06-14": 5.25,
  "2024-06-17": 5.25,
  "2024-06-18": 5.24,
  "2024-06-20": 5.24,
  "2024-06-21": 5.23,
  "2024-06-24": 5.24,
  "2024-06-25": 5.23,
  "2024-06-26": 5.24,
  "2024-06-27": 5.23,
  "2024-06-28": 5.22,
  "2024-07-01": 5.24,
  "2024-07-02": 5.24,
  "2024-07-03": 5.24,
  "2024-07-05": 5.23,
  "2024-07-08": 5.23,
  "2024-07-09": 5.23,
  "2024-07-10": 5.23,
  "2024-07-11": 5.21,
  "2024-07-12": 5.21,
  "2024-07-15": 5.2,
  "2024-07-16": 5.2,
  "2024-07-17": 5.2,
  "2024-07-18": 5.21,
  "2024-07-19": 5.2,
  "2024-07-22": 5.19,
  "2024-07-23": 5.18,
  "2024-07-24": 5.18,
  "2024-07-25": 5.17,
  "2024-07-26": 5.16,
  "2024-07-29": 5.15,
  "2024-07-30": 5.14,
  "2024-07-31": 5.15,
  "2024-08-01": 5.12,
  "2024-08-02": 5.05,
  "2024-08-05": 5.09,
  "2024-08-06": 5.09,
  "2024-08-07": 5.09,
  "2024-08-08": 5.09,
  "2024-08-09": 5.09,
  "2024-08-12": 5.07,
  "2024-08-13": 5.06,
  "2024-08-14": 5.07,
  "2024-08-15": 5.09,
  "2024-08-16": 5.08,
  "2024-08-19": 5.06,
  "2024-08-20": 5.04,
  "2024-08-21": 5.02,
  "2024-08-22": 5.04,
  "2024-08-23": 5.01,
  "2024-08-26": 4.98,
  "2024-08-27": 4.98,
  "2024-08-28": 4.96,
  "2024-08-29": 4.98,
  "2024-08-30": 4.98,
  "2024-09-03": 4.97,
  "2024-09-04": 4.96,
  "2024-09-05": 4.94,
  "2024-09-06": 4.93,
  "2024-09-09": 4.89,
  "2024-09-10": 4.85,
  "2024-09-11": 4.89,
  "2024-09-12": 4.85,
  "2024-09-13": 4.78,
  "2024-09-16": 4.75,
  "2024-09-17": 4.75,
  "2024-09-18": 4.65,
  "2024-09-19": 4.61,
  "2024-09-20": 4.56,
  "2024-09-23": 4.53,
  "2024-09-24": 4.5,
  "2024-09-25": 4.51,
  "2024-09-26": 4.5,
  "2024-09-27": 4.5,
  "2024-09-30": 4.52,
  "2024-10-01": 4.5,
  "2024-10-02": 4.48,
  "2024-10-03": 4.48,
  "2024-10-04": 4.53,
  "2024-10-07": 4.55,
  "2024-10-08": 4.53,
  "2024-10-09": 4.54,
  "2024-10-10": 4.54,
  "2024-10-11": 4.53,
  "2024-10-15": 4.52,
  "2024-10-16": 4.51,
  "2024-10-17": 4.54,
  "2024-10-18": 4.53,
  "2024-10-21": 4.51,
  "2024-10-22": 4.51,
  "2024-10-23": 4.52,
  "2024-10-24": 4.5,
  "2024-10-25": 4.52,
  "2024-10-28": 4.49,
  "2024-10-29": 4.49,
  "2024-10-30": 4.47,
  "2024-10-31": 4.44,
  "2024-11-01": 4.41,
  "2024-11-04": 4.44,
  "2024-11-05": 4.43,
  "2024-11-06": 4.44,
  "2024-11-07": 4.43,
  "2024-11-08": 4.43,
  "2024-11-12": 4.43,
  "2024-11-13": 4.4,
  "2024-11-14": 4.41,
  "2024-11-15": 4.41,
  "2024-11-18": 4.42,
  "2024-11-19": 4.41,
  "2024-11-20": 4.42,
  "2024-11-21": 4.43,
  "2024-11-22": 4.43,
  "2024-11-25": 4.42,
  "2024-11-26": 4.4,
  "2024-11-27": 4.4,
  "2024-11-29": 4.39,
  "2024-12-02": 4.38,
  "2024-12-03": 4.36,
  "2024-12-04": 4.35,
  "2024-12-05": 4.34,
  "2024-12-06": 4.31,
  "2024-12-09": 4.3,
  "2024-12-10": 4.29,
  "2024-12-11": 4.26,
  "2024-12-12": 4.23,
  "2024-12-13": 4.23,
  "2024-12-16": 4.25,
  "2024-12-17": 4.26,
  "2024-12-18": 4.25,
  "2024-12-19": 4.23,
  "2024-12-20": 4.23,
  "2024-12-23": 4.24,
  "2024-12-24": 4.28,
  "2024-12-26": 4.24,
  "2024-12-27": 4.19,
  "2024-12-30": 4.23,
  "2024-12-31": 4.23,
  "2025-01-02": 4.22,
  "2025-01-03": 4.2,
  "2025-01-06": 4.21,
  "2025-01-07": 4.21,
  "2025-01-08": 4.21,
  "2025-01-09": 4.21,
  "2025-01-10": 4.22,
  "2025-01-13": 4.23,
  "2025-01-14": 4.22,
  "2025-01-15": 4.21,
  "2025-01-16": 4.21,
  "2025-01-17": 4.2,
  "2025-01-21": 4.22,
  "2025-01-22": 4.22,
  "2025-01-23": 4.22,
  "2025-01-24": 4.21,
  "2025-01-27": 4.2,
  "2025-01-28": 4.2,
  "2025-01-29": 4.2,
  "2025-01-30": 4.19,
  "2025-01-31": 4.2,
  "2025-02-03": 4.22,
  "2025-02-04": 4.22,
  "2025-02-05": 4.22,
  "2025-02-06": 4.22,
  "2025-02-07": 4.24,
  "2025-02-10": 4.23,
  "2025-02-11": 4.23,
  "2025-02-12": 4.23,
  "2025-02-13": 4.22,
  "2025-02-14": 4.22,
  "2025-02-18": 4.23,
  "2025-02-19": 4.22,
  "2025-02-20": 4.21,
  "2025-02-21": 4.21,
  "2025-02-24": 4.19,
  "2025-02-25": 4.19,
  "2025-02-26": 4.2,
  "2025-02-27": 4.2,
  "2025-02-28": 4.2,
  "2025-03-03": 4.21,
  "2025-03-04": 4.2,
  "2025-03-05": 4.21,
  "2025-03-06": 4.2,
  "2025-03-07": 4.2,
  "2025-03-10": 4.19,
  "2025-03-11": 4.2,
  "2025-03-12": 4.21,
  "2025-03-13": 4.2,
  "2025-03-14": 4.2,
  "2025-03-17": 4.2,
  "2025-03-18": 4.2,
  "2025-03-19": 4.2,
  "2025-03-20": 4.19,
  "2025-03-21": 4.19,
  "2025-03-24": 4.19,
  "2025-03-25": 4.19,
  "2025-03-26": 4.2,
  "2025-03-27": 4.2,
  "2025-03-28": 4.2,
  "2025-03-31": 4.21,
  "2025-04-01": 4.2,
  "2025-04-02": 4.21,
  "2025-04-03": 4.2,
  "2025-04-04": 4.17,
  "2025-04-07": 4.17,
  "2025-04-08": 4.19,
  "2025-04-09": 4.24,
  "2025-04-10": 4.22,
  "2025-04-11": 4.23,
  "2025-04-14": 4.22,
  "2025-04-15": 4.22,
  "2025-04-16": 4.21,
  "2025-04-17": 4.23,
  "2025-04-21": 4.22,
  "2025-04-22": 4.22,
  "2025-04-23": 4.22,
  "2025-04-24": 4.21,
  "2025-04-25": 4.21,
  "2025-04-28": 4.2,
  "2025-04-29": 4.2,
  "2025-04-30": 4.2,
  "2025-05-01": 4.2,
  "2025-05-02": 4.22,
  "2025-05-05": 4.22,
  "2025-05-06": 4.22,
  "2025-05-07": 4.22,
  "2025-05-08": 4.23,
  "2025-05-09": 4.22,
  "2025-05-12": 4.31,
  "2025-05-13": 4.29,
  "2025-05-14": 4.29,
  "2025-05-15": 4.27,
  "2025-05-16": 4.25,
  "2025-05-19": 4.28,
  "2025-05-20": 4.26,
  "2025-05-21": 4.24,
  "2025-05-22": 4.25,
  "2025-05-23": 4.24,
  "2025-05-27": 4.24,
  "2025-05-28": 4.24,
  "2025-05-29": 4.25,
  "2025-05-30": 4.25,
  "2025-06-02": 4.25,
  "2025-06-03": 4.24,
  "2025-06-04": 4.25,
  "2025-06-05": 4.25,
  "2025-06-06": 4.25,
  "2025-06-09": 4.25,
  "2025-06-10": 4.26,
  "2025-06-11": 4.26,
  "2025-06-12": 4.27,
  "2025-06-13": 4.26,
  "2025-06-16": 4.24,
  "2025-06-17": 4.23,
  "2025-06-18": 4.23,
  "2025-06-20": 4.21,
  "2025-06-23": 4.19,
  "2025-06-24": 4.19,
  "2025-06-25": 4.19,
  "2025-06-26": 4.21,
  "2025-06-27": 4.2,
  "2025-06-30": 4.24,
  "2025-07-01": 4.24,
  "2025-07-02": 4.24,
  "2025-07-03": 4.26,
  "2025-07-07": 4.26,
  "2025-07-08": 4.26,
  "2025-07-09": 4.26,
  "2025-07-10": 4.25,
  "2025-07-11": 4.25,
  "2025-07-14": 4.26,
  "2025-07-15": 4.25,
  "2025-07-16": 4.24,
  "2025-07-17": 4.24,
  "2025-07-18": 4.24,
  "2025-07-21": 4.24,
  "2025-07-22": 4.24,
  "2025-07-23": 4.25,
  "2025-07-24": 4.25,
  "2025-07-25": 4.25,
  "2025-07-28": 4.24,
  "2025-07-29": 4.24,
  "2025-07-30": 4.25,
  "2025-07-31": 4.24,
  "2025-08-01": 4.19,
  "2025-08-04": 4.16,
  "2025-08-05": 4.16,
  "2025-08-06": 4.14,
  "2025-08-07": 4.14,
  "2025-08-08": 4.14,
  "2025-08-11": 4.15,
  "2025-08-12": 4.14,
  "2025-08-13": 4.11,
  "2025-08-14": 4.12,
  "2025-08-15": 4.12,
  "2025-08-18": 4.14,
  "2025-08-19": 4.12,
  "2025-08-20": 4.12,
  "2025-08-21": 4.14,
  "2025-08-22": 4.1,
  "2025-08-25": 4.1,
  "2025-08-26": 4.1,
  "2025-08-27": 4.08,
  "2025-08-28": 4.08,
  "2025-08-29": 4.05,
  "2025-09-02": 4.05,
  "2025-09-03": 4.03,
  "2025-09-04": 4.01,
  "2025-09-05": 3.92,
  "2025-09-08": 3.95,
  "2025-09-09": 3.95,
  "2025-09-10": 3.94,
  "2025-09-11": 3.94,
  "2025-09-12": 3.94,
  "2025-09-15": 3.91,
  "2025-09-16": 3.9,
  "2025-09-17": 3.88,
  "2025-09-18": 3.89,
  "2025-09-19": 3.89,
  "2025-09-22": 3.86,
  "2025-09-23": 3.86,
  "2025-09-24": 3.87,
  "2025-09-25": 3.89,
  "2025-09-26": 3.87,
  "2025-09-29": 3.86,
  "2025-09-30": 3.86,
  "2025-10-01": 3.85,
  "2025-10-02": 3.86,
  "2025-10-03": 3.87,
  "2025-10-06": 3.86,
  "2025-10-07": 3.85,
  "2025-10-08": 3.85,
  "2025-10-09": 3.87,
  "2025-10-10": 3.86,
  "2025-10-14": 3.85,
  "2025-10-15": 3.87,
  "2025-10-16": 3.86,
  "2025-10-17": 3.84,
  "2025-10-20": 3.81,
  "2025-10-21": 3.8,
  "2025-10-22": 3.8,
  "2025-10-23": 3.8,
  "2025-10-24": 3.77,
  "2025-10-27": 3.73,
  "2025-10-28": 3.73,
  "2025-10-29": 3.77,
  "2025-10-30": 3.76,
  "2025-10-31": 3.73,
  "2025-11-03": 3.82,
  "2025-11-04": 3.8,
  "2025-11-05": 3.8,
  "2025-11-06": 3.77,
  "2025-11-07": 3.77,
  "2025-11-10": 3.79,
  "2025-11-12": 3.79,
  "2025-11-13": 3.8,
  "2025-11-14": 3.8,
  "2025-11-17": 3.8,
  "2025-11-18": 3.78,
  "2025-11-19": 3.79,
  "2025-11-20": 3.78,
  "2025-11-21": 3.75,
  "2025-11-24": 3.75,
  "2025-11-25": 3.74,
  "2025-11-26": 3.76,
  "2025-11-28": 3.73,
  "2025-12-01": 3.71,
  "2025-12-02": 3.68,
  "2025-12-03": 3.64,
  "2025-12-04": 3.63,
  "2025-12-05": 3.62,
  "2025-12-08": 3.64,
  "2025-12-09": 3.64,
  "2025-12-10": 3.6,
  "2025-12-11": 3.58,
  "2025-12-12": 3.54,
  "2025-12-15": 3.56,
  "2025-12-16": 3.56,
  "2025-12-17": 3.55,
  "2025-12-18": 3.53,
  "2025-12-19": 3.54,
  "2025-12-22": 3.56,
  "2025-12-23": 3.56,
  "2025-12-24": 3.6,
  "2025-12-26": 3.56,
  "2025-12-29": 3.57,
  "2025-12-30": 3.55,
  "2025-12-31": 3.57,
  // 2026
  "2026-01-02": 3.54,
  "2026-01-03": 3.54,
  "2026-01-06": 3.53,
  "2026-01-07": 3.52,
  "2026-01-08": 3.52,
  "2026-01-09": 3.52,
  "2026-01-10": 3.56,
  "2026-01-13": 3.57,
  "2026-01-14": 3.57,
  "2026-01-15": 3.57,
  "2026-01-16": 3.57,
  "2026-01-20": 3.59,
  "2026-01-21": 3.59,
  "2026-01-22": 3.6,
  "2026-01-23": 3.59,
  "2026-01-26": 3.59,
  "2026-01-27": 3.58,
  "2026-01-28": 3.59,
  "2026-01-29": 3.59,
  "2026-01-30": 3.58,
  "2026-02-02": 3.6,
  "2026-02-03": 3.6,
  "2026-02-04": 3.6,
  "2026-02-05": 3.59,
  "2026-02-06": 3.6,
  "2026-02-09": 3.6,
  "2026-02-10": 3.6,
  "2026-02-11": 3.61,
  "2026-02-12": 3.61,
  "2026-02-13": 3.6,
  "2026-02-17": 3.61,
  "2026-02-18": 3.61,
  "2026-02-19": 3.61,
  "2026-02-20": 3.6,
  "2026-02-23": 3.6,
  "2026-02-24": 3.6,
  "2026-02-25": 3.6,
  "2026-02-26": 3.6,
  "2026-02-27": 3.59,
  "2026-03-02": 3.61,
  "2026-03-03": 3.6,
  "2026-03-04": 3.6,
  "2026-03-05": 3.59,
  "2026-03-06": 3.58,
  "2026-03-09": 3.61,
  "2026-03-10": 3.6,
  "2026-03-11": 3.61,
  "2026-03-12": 3.61,
  "2026-03-13": 3.61,
  "2026-03-16": 3.61,
  "2026-03-17": 3.61,
  "2026-03-18": 3.62,
  "2026-03-19": 3.62,
  "2026-03-20": 3.63,
  "2026-03-23": 3.63,
  "2026-03-24": 3.63,
  "2026-03-25": 3.63,
  "2026-03-26": 3.63,
  "2026-03-27": 3.62,
  "2026-03-30": 3.62,
  "2026-03-31": 3.61,
  "2026-04-01": 3.61,
  "2026-04-02": 3.61,
  "2026-04-03": 3.62,
  "2026-04-06": 3.64,
  "2026-04-07": 3.62,
  "2026-04-08": 3.61,
  "2026-04-09": 3.6,
  "2026-04-10": 3.6,
  "2026-04-13": 3.62,
  "2026-04-14": 3.62,
  "2026-04-15": 3.62,
  "2026-04-16": 3.62,
  "2026-04-17": 3.61,
  "2026-04-20": 3.62,
  "2026-04-21": 3.6,
  "2026-04-22": 3.6,
  "2026-04-23": 3.6,
  "2026-04-24": 3.6,
  "2026-04-27": 3.6,
  "2026-04-28": 3.6,
  "2026-04-29": 3.6,
  "2026-04-30": 3.59,
  "2026-05-01": 3.59,
  "2026-05-04": 3.61,
  "2026-05-05": 3.61,
  "2026-05-06": 3.61,
  "2026-05-07": 3.61,
  "2026-05-08": 3.6,
  "2026-05-11": 3.61,
  "2026-05-12": 3.61,
  "2026-05-13": 3.61,
  "2026-05-14": 3.6,
  "2026-05-15": 3.6,
  "2026-05-18": 3.6,
  "2026-05-19": 3.59,
  "2026-05-20": 3.57,
  "2026-05-21": 3.59,
  "2026-05-22": 3.59,
  "2026-05-26": 3.6,
  "2026-05-27": 3.59,
  "2026-05-28": 3.6,
  "2026-05-29": 3.6,
  "2026-06-01": 3.63,
  "2026-06-02": 3.63,
  "2026-06-03": 3.63,
  "2026-06-04": 3.63,
  "2026-06-05": 3.63,
  "2026-06-08": 3.65,
  "2026-06-09": 3.64,
  "2026-06-10": 3.64,
  "2026-06-11": 3.63,
  "2026-06-12": 3.63,
  "2026-06-15": 3.64,
  "2026-06-16": 3.64,
  "2026-06-17": 3.68,
  "2026-06-18": 3.67,
  "2026-06-22": 3.7,
  "2026-06-23": 3.7,
  "2026-06-24": 3.7,
  "2026-06-25": 3.69,
  "2026-06-26": 3.67,
  "2026-06-29": 3.74,
  "2026-06-30": 3.74,
  "2026-07-01": 3.71,
  "2026-07-02": 3.68,
  "2026-07-06": 3.74,
  "2026-07-07": 3.73,
  "2026-07-08": 3.73,
  "2026-07-09": 3.69,
  "2026-07-10": 3.71,
  "2026-07-13": 3.76,
  "2026-07-14": 3.71,
  "2026-07-15": 3.7,
  "2026-07-16": 3.7,
  "2026-07-17": 3.71,
  "2026-07-20": 3.73,
};
